<template>
  <!--<div class="kw_look" v-if="hasLoad" :style="'padding-bottom:'+((buttonCssStyle && buttonCssStyle == 6)?'55px':'')" v-loading="isLoading" >   -->
  <div class="kw_look"  v-if="hasLoad" v-loading="isLoading" :style="pageSetInfo.styleSet.pageBoxStyleSet?pageSetInfo.styleSet.pageBoxStyleSet.styleSetCode:''" kwName="pageBoxStyleSet" @click="kwLookPageBoxClick($event)">
    <!--visitSource = 2  PC端 -->
    <!-- <kw_sphere_image></kw_sphere_image> -->
    <div v-if="visitSource == 2 || visitSource == 3" :id="'print_kw_box_'+pageId" ref="print_kw_box" :class="(ifChild==1 && visitSource==2)?'is_child_look':(ifDialog==1?'pageContentStyleSet':'')" :style="('background:'+pageSetInfo.styleSet.bgColor+';')+(ifDialog==1?('max-height:'+(windowHeight-90)+'px;'):'')" >
      <!-- 顶部平铺  -->
      <template v-for="(item,index) in pageSetInfo.tabPageSet" >
        <div :key="'tabPage_'+index" v-if="(dataInfo['BLOCK_SHOW_'+item.tabPageId] != 0) && item.styleSet.jumpWay == 7" :style="item.styleSet.tabPageForBoxStyleSet?item.styleSet.tabPageForBoxStyleSet.styleSetCode:''" kwName="tabPageForBoxStyleSet">
          <!-- 判断显示条件设置 -->
          <el-row  type="flex" justify="center">
            <el-col :xs="24" :sm="24" :md="24" :lg="item.styleSet.tabScreenLg?item.styleSet.tabScreenLg*1:(pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24)" :xl="item.styleSet.tabScreenXl?item.styleSet.tabScreenXl*1:(pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24)">
              <div>
                <div v-if="(item.styleSet.setHeaderHide != 1)" class="curriculumTitle_pc" :style="(item.styleSet.lookTileTabsCommonStyleSet&&item.styleSet.lookTileTabsCommonStyleSet.styleSetCode)?item.styleSet.lookTileTabsCommonStyleSet.styleSetCode:(pageSetInfo.styleSet.lookTileTabsCommonStyleSet?pageSetInfo.styleSet.lookTileTabsCommonStyleSet.styleSetCode:'')" kwName="lookTileTabsCommonStyleSet">
                  <div :style="item.styleSet.tabPageFieldStyleSet?item.styleSet.tabPageFieldStyleSet.styleSetCode:''" kwName="tabPageFieldStyleSet">
                    <template style="" v-if="(item.styleSet.setHeaderHide != 1)">
                      <img v-if="(item.styleSet.titleIcon == 2)" :src="(item.styleSet.titBgImage?GLOBAL.getFileServeUrl()+item.styleSet.titBgImage:'./img/oneself.png')" class="titleBtnImg" :style="'vertical-align: middle;'+ (item.styleSet.tabPageFieldIconStyleSet?item.styleSet.tabPageFieldIconStyleSet.styleSetCode:'')" kwName="tabPageFieldIconStyleSet"/>
                      <div :class="(item.styleSet.titleIcon != 2?'tabname_pc':'')" :style="'display:inline-block;'+(item.styleSet.tabPageFieldNameStyleSet?item.styleSet.tabPageFieldNameStyleSet.styleSetCode:'')" kwName="tabPageFieldNameStyleSet">{{item.tabName+((item.styleSet.ifShowTotal==1 || (pageSetInfo.styleSet.ifShowTotal==1&&item.styleSet.ifShowTotal!=2))?'('+(item.dataTotal>=0?item.dataTotal:'0')+')':'')}}</div>
                    </template>
                    <div v-if="(item.styleSet.jumpWay == 2)" @click="tabPageToList(item)" class="loadmore" :style="'display: inline-block;'+(item.styleSet.tabPageFieldValueStyleSet?item.styleSet.tabPageFieldValueStyleSet.styleSetCode:'')" kwName="tabPageFieldValueStyleSet">{{pageSetInfo.styleSet.titleHide?pageSetInfo.styleSet.titleHide:'全部'}}</div>
                  </div>
                </div>
                <kw_list v-if="(item.type==1)" :ref="'kw_list_'+index" :id="('kw_list_'+index)" :initPageObj="item" :mainId="mainId" :parentTabIndex="(index)" :ifShowSearch="item.ifShowSearch" @zdyParentEvent="zdyParentEvent" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook"></kw_list>
                <kw_look v-else-if="(item.type==11 || item.type==7 || item.type==5)" :ref="'tabPageSet_kw_look_'+index" :pageInfo="item" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs"></kw_look>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <el-row type="flex" justify="center" :style="pageSetInfo.styleSet.lookCommonRowBoxStyleSet?pageSetInfo.styleSet.lookCommonRowBoxStyleSet.styleSetCode:''" kwName="lookCommonRowBoxStyleSet">
        <el-col :xs="24" :sm="24" :md="24" :lg="pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24" :xl="pageSetInfo.styleSet.rotationChartScreenXl?pageSetInfo.styleSet.rotationChartScreenXl*1:24">
          <div class="clearfix" :style="((ifChild==1 && visitSource==2)?'':'margin: 0 0 5px 0;')+(pageSetInfo.styleSet.lookCommonStyleSet?pageSetInfo.styleSet.lookCommonStyleSet.styleSetCode:'') + (pageSetInfo.styleSet.bgImageStyle?(('background-image:url('+GLOBAL.getFileServeUrl()+pageSetInfo.styleSet.bgImageStyle+');')):(dataInfo.BG_FILE?('background-image:url('+GLOBAL.getFileServeUrl()+dataInfo.BG_FILE+');'):''))" kwName="lookCommonStyleSet">
            <div v-if="pageSetInfo.styleSet.fieldStyle && pageSetInfo.styleSet.fieldStyle==2">
                <kw_information_card :pageSetInfo="pageSetInfo"></kw_information_card>
            </div>
            <div v-else>
              <el-form :ref="'look_form_' + pageId" size="mini" :model="pageSetInfo" :label-width="(ifChild==1 && visitSource==2)?'15px':(visitSource == 2?'130px':'90px')" label-suffix=":" @submit.native.prevent>
                <!-- style="display:table;width:100%;" v-for="rowOne in (pageSetInfo.maxRow+1)" :key="'row_' + rowOne"   v-if="item.row == (rowOne-1)" -->
                  <el-row type="flex" :gutter="10" :style="'margin-left:5px;margin-right:5px;' + ((ifChild==1 && visitSource==2)?'display: inline-flex;width: 100%;':'flex-wrap:wrap;') + 'background:'+ pageSetInfo.styleSet.lookBackground">
                    <template v-for="(item,index) in pageSetInfo.fieldSet" >
                      <template v-if="ifChild==0 || (ifChild==1 && item.fieldRole != 30)">
                        <!-- style="display:table-cell;float:none;vertical-align: middle;" -->
                        <el-col  :key="'lookField_'+index" :xs="(!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1)&&visitSource==2?item.colSpan*(Math.ceil(24/(maxRowColJson.maxCol+1))):24" :sm="(!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1)&&visitSource==2?item.colSpan*(Math.ceil(24/(maxRowColJson.maxCol+1))):24" :md="(!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1)&&visitSource==2?item.colSpan*(Math.ceil(24/(maxRowColJson.maxCol+1))):24" :lg="(!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1)&&visitSource==2?item.colSpan*(Math.ceil(24/(maxRowColJson.maxCol+1))):24" :xl="(!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1)&&visitSource==2?item.colSpan*(Math.ceil(24/(maxRowColJson.maxCol+1))):24" v-show="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)" :class="(!item.styleSet || item.styleSet.showStyle!=7?'forFieldDefault':'forFieldDefaultNull')+((item.styleSet && item.styleSet.showStyle==8)?' titleImgBox':'')" :style="((ifChild==1 && visitSource==2)?'min-width:150px;':'') + (item.styleSet.pageForFieldStyleSet?item.styleSet.pageForFieldStyleSet.styleSetCode:'')" kwName="pageForFieldStyleSet" :id="('field_'+(item.fieldId>0?item.fieldId:item.valuePlugId))">
                          <!-- 默认样式 -->
                          <div v-if="((!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1))">
                            <!-- 判断字段类型并进行区分显示 判断展示形式 1：数字 2：字符 3：日期  4：下拉框  5：弹出层 6:附件上传 -->
                            <template v-if="(item.ifUpdate==0)" >
                              <div v-if="(item.fieldType<=3)" class="" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                                <el-form-item class="Signing_form">
                                  <template slot="label" v-if="(!item.styleSet || item.styleSet.titleNameHide!=2)">
                                    <img v-if="(item.styleSet.imgPosition == 3)" class="leftIcon" :src="item.styleSet.iconImage?(GLOBAL.getFileServeUrl()+item.styleSet.iconImage):require('./img/zhe.png')" :style="item.styleSet.pageFieldImageStyleSet?item.styleSet.pageFieldImageStyleSet.styleSetCode:''" kwName="pageFieldImageStyleSet"/>
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <div v-if="item.fieldRole == 2" v-html="item.defaultValStr" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet"></div>
                                  <template v-else>
                                    <el-input :ref="('field_'+index)" v-model="item.defaultValStr" size="mini" :type="item.showType==1?'textarea':'text'" class="searchInput" @change="bindElementChange(item)" :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'')" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" :disabled="true">
                                      <el-tooltip v-if="item.fieldDescribe" slot="append" effect="dark" :content="item.fieldDescribe" placement="top">
                                        <kw_icon  type="message_fill" />
                                      </el-tooltip>
                                    </el-input>
                                  </template>
                                  
                                 
                                  <!-- <div :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" class="defaultStyle">{{item.styleSet.priceUnit ? item.styleSet.priceUnit : ''}}{{item.defaultValStr}}</div> -->
                                </el-form-item>
                              </div>
                              <div v-else-if="(item.fieldType==5)">
                                <el-form-item class="Signing_form" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" v-if="(item.addStyle==3)" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet" >
                                  <!-- 点击加号添加 -->
                                  <template slot="label" class="titleName" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <div :style="'background: #bbb9b9;'+(item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:'')" kwName="pageFieldValueStyleSet" class="defaultStyle">
                                    <kw_icon type="add" style="padding-left: 5px;padding-right: 5px;"  />
                                    <!-- @click="addChildJson(item,index)" -->
                                  </div>
                                </el-form-item>
                                <kw_dialog_field v-else v-show="!(item.styleSet.dialogIfHide==1)" v-model="pageSetInfo.fieldSet[index]" :ref="('field_'+index)" :id="('field_'+index)" :nowDataId="(item.defaultCheckValue)" :filedIndex="item.prevFieldIndex+':'+item.nowFieldIndex+'-'+nowDataIndex" :pageSetInfo="pageSetInfo" :nowDataIndex="nowDataIndex+''" @dialogFieldCallBack="dialogFieldCallBack"  @getParentKwLook="getParentKwLook" :isLimitButton="isLimitButton" :fieldSetindex="index"></kw_dialog_field>
                              </div>
                              <div v-else-if="(item.fieldType==6)">
                                <el-form-item class="Signing_form">
                                  <div slot="label" class="titleName" v-if="(!item.styleSet ||item.styleSet.titleNameHide!=2)">
                                    <img v-if="(item.styleSet.imgPosition == 3)" class="leftIcon" :src="item.styleSet.iconImage?(GLOBAL.getFileServeUrl()+item.styleSet.iconImage):require('./img/zhe.png')" :style="item.styleSet.pageFieldImageStyleSet?item.styleSet.pageFieldImageStyleSet.styleSetCode:''" kwName="pageFieldImageStyleSet"/>
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName}}:</span>
                                  </div>
                                  <el-table v-if="item.fileList && item.fileList.length > 0"
                                    :data="item.fileList"
                                    style="width: 100%">
                                    <el-table-column
                                      prop="name"
                                      label="文件名称">
                                    </el-table-column>
                                    <el-table-column
                                      label="操作">
                                      <template slot-scope="scope">
                                        <el-button @click="toPreviewFile(scope.row,item)" type="text" size="small">预览</el-button>
                                        <el-button v-if="item.ifonlyPreView!=1" @click="downLoadFile(scope.row,item)" type="text" size="small">下载</el-button>
                                        <!-- <el-button @click="removeFile(scope.row,item.fileList,item)" type="text" size="small">删除</el-button> -->
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </el-form-item>
                              </div>
                              <div v-else-if="(!item.childFieldSet || item.childFieldSet.length <= 1)" class="" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                                <el-form-item class="Signing_form">
                                  <template slot="label" v-if="(!item.styleSet || item.styleSet.titleNameHide!=2)">
                                    <img v-if="(item.styleSet.imgPosition == 3)" class="leftIcon" :src="item.styleSet.iconImage?(GLOBAL.getFileServeUrl()+item.styleSet.iconImage):require('./img/zhe.png')" :style="item.styleSet.pageFieldImageStyleSet?item.styleSet.pageFieldImageStyleSet.styleSetCode:''" kwName="pageFieldImageStyleSet"/>
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <el-input :ref="('field_'+index)" :value="item.fieldType==4?item.defaultCheckCnName:item.defaultValStr" size="mini" :type="item.showType==1?'textarea':'text'" class="searchInput" @change="bindElementChange(item)"  :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'')" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" :disabled="true">
                                    <el-tooltip v-if="item.fieldDescribe" slot="append" effect="dark" :content="item.fieldDescribe" placement="top">
                                      <kw_icon  type="message_fill" />
                                    </el-tooltip>
                                  </el-input>
                                </el-form-item>
                              </div>
                            </template>
                            <template v-else>
                              <!-- 数字类型 1 -->
                              <div v-if="(item.fieldType==1)">
                                <el-form-item :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.defaultValStr'" class="Signing_form">
                                  <template slot="label" v-if="(item.styleSet.titleNameHide!=2)">
                                      <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                    </template>
                                  <el-input v-model="item.defaultValStr" size="mini" class="searchInput" @blur="bindElementChange(item)"  :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'')"
                                            :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''"
                                            kwName="pageFieldValueStyleSet"
                                  >
                                    <el-tooltip v-if="item.fieldDescribe" slot="append" effect="dark" :content="item.fieldDescribe" placement="top">
                                      <kw_icon  type="message_fill" />
                                    </el-tooltip>
                                  </el-input>
                                </el-form-item>
                              </div>
                              <!-- 字符类型 2 -->
                              <div v-else-if="(item.fieldType==2)">
                                <!-- 手机号类型 是否短信验证码校验 -->
                                <div v-if="item.styleSet && item.styleSet.ifPhoneMsgCheck == 1">
                                  <el-form-item :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.defaultValStr'" class="Signing_form">
                                    <template slot="label" v-if="(item.styleSet.titleNameHide!=2)">
                                      <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                    </template>
                                      <el-input type="tel" v-model="item.defaultValStr" maxlength="11" class="searchInput" size="mini" @blur="bindElementChange(item)" :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'')"
                                            :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">
                                        <el-tooltip v-if="item.fieldDescribe" slot="append" effect="dark" :content="item.fieldDescribe" placement="top">
                                          <kw_icon  type="message_fill" />
                                        </el-tooltip>
                                      </el-input>
                                  </el-form-item>
                                  <el-form-item label="验证码"  class="Signing_form" >
                                      <el-input type="text" class="searchInput" size="mini" v-model="yzmCode" maxlength="6" placeholder="输入验证码" @blur="checkPhoneYzm(item)" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">
                                          <el-button @click="sendMsgYzm(item)" :loading="yzmFlag" slot="append" style="border:1px solid #DADDE5;background-color: #DCDFE6;padding: 12px 5px;border-top-left-radius: 0;border-bottom-left-radius: 0" >{{yzmText}}</el-button>
                                      </el-input>
                                  </el-form-item>
                                </div>
                                <!-- 密码字段修改 -->
                                <el-form-item v-else-if="item.fieldRole == 24" :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.defaultValStr'" class="Signing_form" >
                                  <template slot="label" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <el-input v-model="item.defaultValStr" type="password" size="mini" class="searchInput" @blur="bindElementChange(item)" :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'')"
                                            :style="'width:'+(item.styleSet.searchInputWidth)+';padding:'+(item.styleSet.searchInputPad?item.styleSet.searchInputPad:'3px 10px')+';margin:'+(item.styleSet.searchInputMargin)"
                                  >
                                    <el-tooltip v-if="item.fieldDescribe" slot="append" effect="dark" :content="item.fieldDescribe" placement="top">
                                      <kw_icon  type="message_fill" />
                                    </el-tooltip>
                                  </el-input>
                                </el-form-item>
                                <!-- 富文本字段  fieldRole -->
                                 <el-form-item v-else-if="item.fieldRole == 2" :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.defaultValStr'" class="Signing_form" >
                                  <template slot="label" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <!-- 签字版 -->
                                  <template v-if="item.showType==1">
                                    <kw_signature_pad v-model="pageSetInfo.fieldSet[index]" :nowDataId="(item.defaultCheckValue)" :filedIndex="item.prevFieldIndex+':'+item.nowFieldIndex+'-'+nowDataIndex" :pageSetInfo="pageSetInfo" :nowDataIndex="nowDataIndex+''" @dialogFieldCallBack="dialogFieldCallBack"  @getParentKwLook="getParentKwLook" @bindElementChange="bindElementChange" :isLimitButton="isLimitButton" :fieldSetindex="index"></kw_signature_pad>
                                  </template>
                                  <vue-ueditor-wrap v-else ref="myTextEditor" v-model="item.defaultValStr" :config="item.styleSet.UEditorConfig?item.styleSet.UEditorConfig:UEditorSampleConfig" @contentChange="bindElementChange(item)" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet"></vue-ueditor-wrap>
                                </el-form-item>
                                <el-form-item v-else :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.defaultValStr'" class="Signing_form" >
                                  <template slot="label" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <el-input :ref="('field_'+index)" v-model="item.defaultValStr" size="mini" :type="item.showType==1?'textarea':'text'" class="searchInput" @change="bindElementChange(item)" :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'')"
                                            :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''"
                                            kwName="pageFieldValueStyleSet"
                                  >
                                    <el-tooltip v-if="item.fieldDescribe" slot="append" effect="dark" :content="item.fieldDescribe" placement="top">
                                      <kw_icon  type="message_fill" />
                                    </el-tooltip>
                                  </el-input>
                                </el-form-item>
                              </div>
                              <!-- 日期类型 3 -->
                              <div v-else-if="(item.fieldType==3)">
                                <el-form-item :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.defaultValStr'" class="Signing_form" >
                                  <template slot="label" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <el-date-picker v-if="item.dataTypeXcx == 'date'" class="searchInput" size="mini" style="width:100%"
                                                  :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''"
                                                  kwName="pageFieldValueStyleSet"
                                                  v-model="item.defaultValStr"
                                                  :type="item.dateType=='yyyy'?'year':(item.dateType=='yyyy-MM'?'month':'date')"
                                                  :format="item.dateType.replace(/-/g,'/')"
                                                  :value-format="item.dateType"
                                                  placeholder="选择日期"
                                                  @blur="bindElementChange(item)" clearable
                                  >
                                  </el-date-picker>
                                  <el-time-picker v-else-if="item.dataTypeXcx == 'time'" class="searchInput" size="mini" style="width:100%"
                                                  :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''"
                                                  kwName="pageFieldValueStyleSet"
                                                  v-model="item.defaultValStr"
                                                  :format="item.dateType.replace(/-/g,'/')"
                                                  :value-format="item.dateType"
                                                  placeholder="选择时间"
                                                  @blur="bindElementChange(item)" clearable
                                  >
                                  </el-time-picker>
                                  <el-date-picker v-else class="searchInput" size="mini" style="width:100%"
                                                  :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''"
                                                  kwName="pageFieldValueStyleSet"
                                                  v-model="item.defaultValStr"
                                                  type="datetime"
                                                  :format="item.dateType.replace(/-/g,'/')"
                                                  :value-format="item.dateType"
                                                  placeholder="选择日期时间"
                                                  @blur="bindElementChange(item)" clearable
                                  >
                                  </el-date-picker>
                                </el-form-item>
                              </div>
                              <!-- 下拉框类型 4 -->
                              <div v-else-if="(item.fieldType==4)">
                                <el-form-item :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="item.fieldRole==16?('fieldSet.'+index+'.defaultCheckValue'):('fieldSet.'+index+'.defaultCheckIndexArr')" clearable class="Signing_form">
                                  <template slot="label" class="titleName" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <template v-if="item.selectStyle==1">
                                    <el-radio-group v-if="item.fieldRole==16" :style="(item.fieldDescribe?'width:90%;':'width:100%;')+(item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:'')" v-model="item.defaultCheckValue" @change="bindElementChange(item)"
                                            kwName="pageFieldValueStyleSet">
                                      <el-radio v-for="(dicItem,dicIndex) in item.dicList" :key="dicIndex"  class="radio_right" :label="dicItem.DIC_ID" :style="styleSetCodeZdy(item.styleSet.pageFieldValueDicStyleSet,dataInfo,dicIndex)" kwName="pageFieldValueDicStyleSet" >{{dicItem.DIC_NAME}}</el-radio>
                                    </el-radio-group>
                                    <el-checkbox-group v-else v-model="item.defaultCheckIndexArr" :style="(item.fieldDescribe?'width:90%;':'width:100%;')+(item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:'')"  @change="bindElementChange(item)" kwName="pageFieldValueStyleSet">
                                      <el-checkbox v-for="(dicItem,dicIndex) in item.dicList" :key="dicIndex" :label="dicIndex" :style="(item.styleSet.pageFieldValueDicStyleSet?item.styleSet.pageFieldValueDicStyleSet.styleSetCode:'')" kwName="pageFieldValueDicStyleSet" >{{dicItem.DIC_NAME}}</el-checkbox>
                                    </el-checkbox-group>
                                  </template>
                                  <template v-else>
                                    <el-select v-if="item.fieldRole==16" :filterable="(item.dicList && item.dicList.length > 10)?true:false" :style="item.fieldDescribe?'width:90%;':'width:100%;'" v-model="item.defaultCheckValue" placeholder="请选择" @change="bindElementChange(item)" clearable>
                                      <el-option v-for="(dicItem,dicIndex) in item.dicList" :key="dicIndex"
                                                :label="dicItem.DIC_NAME"
                                                :value="dicItem.DIC_ID">
                                      </el-option>
                                    </el-select>
                                    <el-select v-else :filterable="(item.dicList && item.dicList.length > 10)?true:false" v-model="item.defaultCheckIndexArr" placeholder="请选择" :style="item.fieldDescribe?'width:90%;':'width:100%;'"  @change="bindElementChange(item)" multiple>
                                      <el-option v-for="(dicItem,dicIndex) in item.dicList" :key="dicIndex"
                                                :label="dicItem.DIC_NAME"
                                                :value="dicIndex">
                                      </el-option>
                                    </el-select>
                                  </template>
                                  <el-tooltip v-if="item.fieldDescribe" effect="dark" :content="item.fieldDescribe" placement="top">
                                    <kw_icon  type="message_fill" />
                                  </el-tooltip>
                                </el-form-item>
                              </div>
                              <!-- 弹出层类型 5 -->
                              <div v-else-if="(item.fieldType==5)">
                                <el-form-item class="Signing_form" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.childPageJsonArr'" v-if="(item.addStyle==3)" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet" >
                                  <!-- 点击加号添加 -->
                                  <template slot="label" class="titleName" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <div :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" class="defaultStyle">
                                    <kw_icon type="add" style="padding-left: 5px;" @click="addChildJson(item,index)" />
                                  </div>
                                </el-form-item>
                                <kw_dialog_field v-else v-show="!(item.styleSet.dialogIfHide==1)" v-model="pageSetInfo.fieldSet[index]" :ref="('field_'+index)" :id="('field_'+index)" :nowDataId="(item.defaultCheckValue)" :filedIndex="item.prevFieldIndex+':'+item.nowFieldIndex+'-'+nowDataIndex" :pageSetInfo="pageSetInfo" :nowDataIndex="nowDataIndex+''" @dialogFieldCallBack="dialogFieldCallBack"  @getParentKwLook="getParentKwLook" :isLimitButton="isLimitButton" :fieldSetindex="index"></kw_dialog_field>
                              </div>
                              <!-- 附件上传 6 -->
                              <div v-else-if="(item.fieldType==6)">
                                <el-form-item :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" :prop="'fieldSet.'+index+'.defaultValStr'" class="Signing_form">
                                  <template slot="label" class="titleName" v-if="(item.styleSet.titleNameHide!=2)">
                                    <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" class="pageFieldNameStyleSet" kwName="pageFieldNameStyleSet">{{item.fieldCnName + ':'}}</span>
                                  </template>
                                  <el-upload :multiple="(item.fileNum==1?false:true)"
                                    class="upload-demo" :drag="(item.styleSet && item.styleSet.fileUploadDrag==1)?true:false"
                                    :style="'width:'+(item.styleSet.searchInputWidth?item.styleSet.searchInputWidth:'100%')+';padding:'+(item.styleSet.searchInputPad?item.styleSet.searchInputPad:'3px 10px')+';margin:'+(item.styleSet.searchInputMargin)"
                                    :with-credentials="true"
                                    :action="'/'+GLOBAL.projectName+'/servlet/OmFileUploadServlet'"
                                    :on-success="(response, file, fileList)=> successFile(response, file, fileList,item)"
                                    :on-error="(err, file, fileList)=> errorFile(err, file, fileList,item)"
                                    :on-remove="(file, fileList)=> removeFile(file, fileList,item)"
                                    :on-exceed="(files, fileList)=> exceedFile(files, fileList,item)"
                                    :on-progress="(files, fileList)=> progressFile(files, fileList,item)"
                                    :on-preview="(file)=> downLoadFile(file,item)"
                                    :before-upload="(file)=> beforeUploadLoadFile(file,item)"
                                    :list-type="'text'"
                                    :limit="item.fileNum"
                                    :file-list="item.fileList"
                                    :show-file-list="item.showFileListFlag>0?(item.showFileListFlag==1?true:false):false"
                                  >

                                    <template v-if="(item.styleSet && item.styleSet.fileUploadDrag==1)">
                                      <i class="el-icon-upload"></i>
                                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                    </template>
                                    <el-button v-else slot="trigger" size="small" type="primary" @click="clickElUpload(index,item)">
                                      <template v-if="item.loadingFile">
                                        正在上传中,请稍后
                                      </template>
                                      <template v-else>
                                        点击上传
                                      </template>
                                    </el-button>
                                      <!-- <el-tooltip v-if="item.fieldDescribe" slot="append" effect="dark" :content="item.fieldDescribe" placement="top">
                                      <kw_icon  type="message_fill" />
                                    </el-tooltip> -->
                                    <div slot="tip" class="el-upload__tip" v-if="item.fileType || item.fieldDescribe">
                                      <template v-if="item.fieldDescribe">{{item.fieldDescribe}}</template>
                                      <template v-if="item.fileType">只能上传{{item.fileType}}格式的文件</template>
                                      <!-- 只能上传图片(jpg/png)/音频(mp3)/视频文件(mp4/m3u8/flv)格式 -->
                                    </div>
                                  </el-upload>
                                  <el-table v-if="item.fileList && item.fileList.length > 0"
                                    :data="item.fileList"
                                    style="width: 100%">
                                    <el-table-column
                                      prop="name"
                                      label="文件名称">
                                    </el-table-column>
                                    <el-table-column
                                      label="操作">
                                      <template slot-scope="scope">
                                        <el-button @click="toPreviewFile(scope.row,item)" type="text" size="small">预览</el-button>
                                        <el-button v-if="item.ifonlyPreView!=1" @click="downLoadFile(scope.row,item)" type="text" size="small">下载</el-button>
                                        <el-button v-if="item.ifonlyPreView!=1" @click="removeFile(scope,item.fileList,item)" type="text" size="small">删除</el-button>
                                      </template>
                                    </el-table-column>
                                  </el-table>
                                </el-form-item>
                              </div>
                            </template>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==2)"> <!-- 轮播图组件 -->
                            <kw_carousel v-model="pageSetInfo.fieldSet[index]"  :previewVisitSource="previewVisitSource"></kw_carousel>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==3)" > <!-- 动态标签组件 -->
                            <kw_label_col v-model="pageSetInfo.fieldSet[index]"></kw_label_col>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==4)" > <!-- 切换组件 -->
                            <kw_change_look :initData="item" :nowDataId="mainId" ></kw_change_look>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==5)" v-show="!(item.styleSet.dialogIfHide==1)" > <!-- 弹出层组件(默认打开) v-show="!(item.styleSet.dialogIfHide==1)" -->
                            <kw_dialog_field  v-model="pageSetInfo.fieldSet[index]" :ref="('field_'+index)" :id="('field_'+index)" :nowDataId="item.defaultCheckValue" :filedIndex="item.prevFieldIndex+':'+item.nowFieldIndex+'-'+nowDataIndex"  :pageSetInfo="pageSetInfo" :nowDataIndex="nowDataIndex+''" @dialogFieldCallBack="dialogFieldCallBack" @getParentKwLook="getParentKwLook" :isLimitButton="isLimitButton"  :fieldSetindex="index"></kw_dialog_field>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==6)" > <!-- 横向标签显示 -->
                            <kw_label_row v-model="pageSetInfo.fieldSet[index]"></kw_label_row>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==8)">  <!-- 带背景图片的单行title -->
                            <div class="bgImageBox" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                              <span class="bgImageName" v-if="(!item.styleSet.titleNameHide || item.styleSet.titleNameHide==1)" :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet">{{item.fieldCnName}}:</span>
                              <span class="bgImageText" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">{{item.defaultValStr}}</span>
                            </div>
                          </div>

                          <div v-else-if="(item.styleSet.showStyle==9 && pageSetInfo.styleSet.fieldStyle!=3)"> <!-- 主标题 -->
                            <span class="mainTitle fieldDefault9" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" @click="elementClick(item)">{{item.defaultValStr}}</span>
                          </div>
                          <template v-else-if="(item.styleSet.showStyle==10 && pageSetInfo.styleSet.fieldStyle!=3)"> <!-- 副标题 -->
                            <div class="viceTitle fieldDefault10" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet" @click="elementClick(item)" >
                              <div :style="item.styleSet.pageFieldNameBoxStyleSet?item.styleSet.pageFieldNameBoxStyleSet.styleSetCode:''" kwName="pageFieldNameBoxStyleSet" class="fieldNameBoxDefault10">
                                <img v-if="(item.styleSet.imgPosition == 3)" class="leftIcon" :src="item.styleSet.iconImage?(GLOBAL.getFileServeUrl()+item.styleSet.iconImage):require('./img/infoIcon.png')" :style="item.styleSet.pageFieldImageStyleSet?item.styleSet.pageFieldImageStyleSet.styleSetCode:''" kwName="pageFieldImageStyleSet"/>
                                <span v-if="(item.styleSet.titleNameHide!=2)" :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet" class="fieldNameDefault10">
                                  {{item.fieldCnName}}<span v-if="(item.styleSet.nameShowIcon!=2)">：</span>
                                </span>
                              </div>
                              <div :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" class="fieldValueDefault10"><span :style="'font-size:'+item.styleSet.priceUnitSize">{{item.styleSet.priceUnit ? item.styleSet.priceUnit:''}}</span>{{item.defaultValStr}}</div>
                            </div>
                          </template>
                          <div v-else-if="(item.styleSet.showStyle==11)" style="display:flex;"> <!-- 人员头像列表 -->
                            <div class="bgImageName" v-if="(item.styleSet && item.styleSet.titleNameHide==1)" :style="'display: flex;align-items: center;padding: 0 0 10px 0;'+(item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:'')" kwName="pageFieldNameStyleSet">{{item.fieldCnName}}:</div>
                            <div class="personnelHeadPortrait" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                              <kw_avatar :initDataInfo="dataInfo" :lookFieldInfo="item" :initFieldInfo="item" ></kw_avatar>
                            </div>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==12)"> <!-- 单行两列 -->
                            <div class="orderNum" :style="item.styleSet.pageFieldDoubleBoxStyleSet?item.styleSet.pageFieldDoubleBoxStyleSet.styleSetCode:''" kwName="pageFieldDoubleBoxStyleSet">
                              <div :class="'leftPart_pc '+(item.styleSet.titleNameHide==3 ? 'botName botNameLeft' : '')" @click="elementClick(item)" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                                <div v-if="(item.styleSet.titleNameHide==3)" class="botNameItem">
                                  <div :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">{{item.defaultValStr}}</div>
                                  <div :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet">
                                    {{item.fieldCnName}}
                                    <img v-if="(item.styleSet.jumpIcon&&item.styleSet.jumpIcon == 1)" src="./img/jtIcon.png" class="jumpIcon_pc"/>
                                  </div>
                                </div>
                                <div v-else>
                                  <span v-if="(item.styleSet.titleNameHide!=2)" :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet">{{item.fieldCnName}}：</span>
                                  <span :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">{{item.defaultValStr}}</span>
                                </div>
                              </div>
                              <div :class="'rightPart_pc '+(item.styleSet.titleNameHide==3 ? 'botName botNameRight' : '')" @click="elementClick(pageSetInfo.fieldSet[index+1])" :style="pageSetInfo.fieldSet[index+1].styleSet.pageFieldStyleSet?pageSetInfo.fieldSet[index+1].styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                                <div v-if="(item.styleSet.titleNameHide==3)" class="botNameItem">
                                  <div v-if="(pageSetInfo.fieldSet[index+1].styleSet.showStyle==22)" :style="pageSetInfo.fieldSet[index+1].styleSet.pageFieldValueStyleSet?pageSetInfo.fieldSet[index+1].styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet"> <!-- 倒计时隐藏 -->
                                    <kw_count_down :target="pageSetInfo.fieldSet[index+1].defaultValStr*1000" ></kw_count_down>
                                  </div>
                                  <div v-else :style="pageSetInfo.fieldSet[index+1].styleSet.pageFieldValueStyleSet?pageSetInfo.fieldSet[index+1].styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">{{item.styleSet.priceUnit && pageSetInfo.fieldSet[index+1].defaultValStr ? item.styleSet.priceUnit : ''}}{{pageSetInfo.fieldSet[index+1].defaultValStr}}</div>
                                  <div :style="pageSetInfo.fieldSet[index+1].styleSet.pageFieldNameStyleSet?pageSetInfo.fieldSet[index+1].styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet">
                                    {{pageSetInfo.fieldSet[index+1].fieldCnName}}
                                    <img v-if="(pageSetInfo.fieldSet[index+1].styleSet.jumpIcon&&pageSetInfo.fieldSet[index+1].styleSet.jumpIcon == 1)" src="./img/jtIcon.png" class="jumpIcon_pc"/>
                                  </div>
                                </div>
                                <div v-else>
                                  <span  v-if="(pageSetInfo.fieldSet[index+1].styleSet.titleNameHide!=2)"  :style="pageSetInfo.fieldSet[index+1].styleSet.pageFieldNameStyleSet?pageSetInfo.fieldSet[index+1].styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet">{{pageSetInfo.fieldSet[index+1].fieldCnName}}：</span>
                                  <div :class="'toInline '+(item.styleSet.rightType&&item.styleSet.rightType==1 ? 'btnType' : '')" :style="pageSetInfo.fieldSet[index+1].styleSet.pageFieldValueStyleSet?pageSetInfo.fieldSet[index+1].styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet">{{item.styleSet.priceUnit && pageSetInfo.fieldSet[index+1].defaultValStr ? item.styleSet.priceUnit : ''}}{{pageSetInfo.fieldSet[index+1].defaultValStr}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==13)"> <!-- 徽章称号 -->
                            <div :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                              <span class="medalText" :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet">称号</span>
                              <kw_medal :lookFieldInfo="item" ></kw_medal>
                            </div>
                          </div>

                          <div v-else-if="(item.styleSet.showStyle==14)"> <!-- 图片 -->
                            <kw_preview_image :styleSet="item.styleSet" :imgSrc="item.defaultValStr"></kw_preview_image>
                          </div>

                          <div v-else-if="(item.styleSet.showStyle==15)"> <!-- 状态聚合样式 -->
                            <div :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                              <kw_having_view :initDataInfo="dataInfo" :initpageSetInfo="pageSetInfo" :item="item" :previewVisitSource="previewVisitSource"></kw_having_view>
                            </div>
                          </div>

                          <div v-else-if="(item.styleSet.showStyle==16)"> <!-- 评价组件 -->
                            <div :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" kwName="pageFieldStyleSet">
                              <span v-if="(item.ifMust==1)" style='color:red;'>*</span>
                              <span :style="item.styleSet.pageFieldNameStyleSet?item.styleSet.pageFieldNameStyleSet.styleSetCode:''" kwName="pageFieldNameStyleSet">{{item.fieldCnName}}:</span>
                              <el-rate v-model="item.defaultCheckValue" :disabled="item.ifUpdate==0?true:false" v-show="!item.ifHide" @change="bindElementChange(item)" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet" ></el-rate>
                            </div>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==18)"> <!-- 富文本组件 -->
                            <div :style="'margin:0 10px;' + (item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:'')" kwName="pageFieldStyleSet">
                              <div v-html="item.defaultValStr"></div>
                            </div>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==19)"> <!-- 进度条组件 -->
                            <div :style="'width: 90%;margin-left: 20px;'+ (item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:'')" kwName="pageFieldStyleSet">
                              <el-progress :percentage="(item.defaultValStr)"></el-progress>
                            </div>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==20)"> <!-- 单行右侧是否 -->
                            <el-form-item :label="item.defaultValStr" >
                              <el-radio-group v-model="pageSetInfo.fieldSet[index+1].defaultCheckValueIndexe">
                                <el-radio v-for="(dicItem,dicIndex) in pageSetInfo.fieldSet[index+1].dicList" :key="dicIndex" :label="dicItem.DIC_NAME" :value="dicItem.DIC_ID" ></el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==21)"> <!-- 倒计时 -->
                            <kw_count_down :target="item.defaultValStr*1000" ></kw_count_down>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==23)"> <!-- 视频 -->
                            <!-- <video oncontextmenu="return false" :style="item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:''" controls="controls" :src="GLOBAL.getFileServeUrl()+item.defaultValStr"></video> -->
                            <kw_video :fieldInfo="item" :mainId="mainId+''" @getParentKwLook="getParentKwLook" :pageSetInfo="pageSetInfo" :dataInfo="dataInfo"></kw_video>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==24)"> <!-- 音频 -->
                            <kw_audio :fieldInfo="item" :mainId="mainId+''" @getParentKwLook="getParentKwLook" :pageSetInfo="pageSetInfo" :dataInfo="dataInfo"></kw_audio>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==25)"> <!-- 角色数据看板 -->
                            <kw_data_console></kw_data_console>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==26)"> <!-- 定位组件-图片 -->
                            <kw_location_image :styleSet="item.styleSet" :imgSrc="item.defaultValStr" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo"  ></kw_location_image>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==29)"> <!-- 数字加减 -->
                            <el-form-item :label="item.fieldCnName" :rules="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)?item.elRules:null" class="Signing_form">
                              <el-input-number v-model="item.defaultValStr" @change="bindElementChange(item)" :min="item.styleSet.minNumber*1" :max="item.styleSet.maxNumber*1" :placeholder="(item.styleSet.searchPlaceholder?item.styleSet.searchPlaceholder:'')" :style="item.styleSet.pageFieldValueStyleSet?item.styleSet.pageFieldValueStyleSet.styleSetCode:''" kwName="pageFieldValueStyleSet"></el-input-number>
                            </el-form-item>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==30)"> <!-- 地图地址 -->
                            <!-- Gis地图天地图 -->
                            <kw_gis v-if="item.styleSet.mapType == 3" v-model="pageSetInfo.fieldSet[index]"  :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" ></kw_gis>
                            <!-- 百度地图 -->
                            <kw_map_drawing v-else-if="item.styleSet.mapType == 2" v-model="pageSetInfo.fieldSet[index]"  :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" ></kw_map_drawing>
                            <!-- 高德地图 -->
                            <kw_map_amap v-else v-model="pageSetInfo.fieldSet[index]"  :pageSetInfo="pageSetInfo" :dataInfo="dataInfo"  :ifRefresh="pageSetInfo.ifRefresh"></kw_map_amap>
                            
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==32)"> <!-- 角色栏目组件 -->
                            <kw_menu></kw_menu>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==33)"> <!-- 排课组件 -->
                            <kw_make_schedule :ref="'kw_make_schedule'" :courseIdKey="'T_' + pageSetInfo.fieldSet[index-1].relationTableId + '_0'" :initCourseList="dataInfo.COURSE_LIST" :initScheduleData="dataInfo.SCHEDULE" :filedIndex="item.prevFieldIndex+':'+item.nowFieldIndex+'-'+nowDataIndex" :scheduleIndex="index" v-model="pageSetInfo" :dataInfo="dataInfo" @changeScheduleData="changeScheduleData" ></kw_make_schedule>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==34)"> <!-- 工作台组件 -->
                            <kw_work_plat v-model="pageSetInfo.fieldSet[index]" :roleId="mainId" :isLimitButton="isLimitButton"></kw_work_plat>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==35)"> <!-- 周排课组件 -->
                            <div v-if="(item.childFieldSet && item.childFieldSet.length > 1)">
                              <div v-for="(childOne,childIndex) in item.childPageJsonArr" :key="'childLook_'+childOne.defaultIdStr"
                                  :style="'padding: 0 22px;background:#fff;border: 1px solid green;margin-top:10rpx;'+(item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:'')" kwName="pageFieldStyleSet"
                              >
                                <span style="float: right;font-size: 12px;margin-right:5px">{{childIndex+1}}</span>
                                <kw_look :ref="('kw_look_'+item.fieldId + '_' + childIndex)" :class="('kw_look_'+item.fieldId)" :initMainId="childOne.updateDataId" :ifChild="1" :initPageSetInfo="childOne" @goBack="goBack" @getParentKwLook="getParentKwLook" :isLimitButton="isLimitButton" :nowDataIndex="childIndex+''" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs"></kw_look>
                              </div>
                            </div>
                            <kw_make_week v-model="pageSetInfo.fieldSet[index]"></kw_make_week>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==36)"> <!-- 直播流播放组件 -->
                            <ali-player ref="player" class="aliplayer" :width="item.styleSet.pageFieldValueStyleSet&&item.styleSet.pageFieldValueStyleSet.width?item.styleSet.pageFieldValueStyleSet.width:'500px'" :height="item.styleSet.pageFieldValueStyleSet&&item.styleSet.pageFieldValueStyleSet.height?item.styleSet.pageFieldValueStyleSet.height:'400px'" control-bar-visibility="hover" :autoplay="true" :isLive="true" :rePlay="false" :useH5Prism="true" :source="item.defaultValStr" />
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==37)"> <!-- 试题组件 -->
                            <Question ref="questionInfo_ref" v-if="parentQuestionInfo && parentQuestionInfo.ifChild==1" :initShowType="parentQuestionInfo.initShowType" :initQuestionId="parentQuestionInfo.initQuestionId" :pageInfo="pageInfo" :initQuestionName="parentQuestionInfo.questionName" :ifImport="parentQuestionInfo.ifImport" :ifChild="parentQuestionInfo.ifChild" :childIndex="parentQuestionInfo.childIndex" :parentQuestionInfo="parentQuestionInfo.parentQuestionInfo"></Question>
                           
                            <Question ref="questionInfo_ref" v-else :initShowType="pageType==5?0:(pageType==7?1:2)" :initQuestionId="mainId" :pageInfo="pageInfo"></Question>
                          </div>
                          <div v-else-if="(item.styleSet.showStyle==38)"> <!-- 全景图组件 -->
                            <kw_sphere_image :styleSet="item.styleSet" :imgSrc="item.defaultValStr" :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" :ifRefresh="pageSetInfo.ifRefresh" @getParentKwList=getParentKwList @getNowKwLook=getNowKwLook></kw_sphere_image>
                          </div>
                          <template v-else-if="(item.styleSet.showStyle==39)"> <!-- 二维码组件 -->
                            <vue-qr  :text="item.defaultValStr" :size="(item.styleSet.pageFieldValueStyleSet&&item.styleSet.pageFieldValueStyleSet.width)?item.styleSet.pageFieldValueStyleSet.width.replace('px','')*1:200" :margin="(item.styleSet.pageFieldValueStyleSet&&item.styleSet.pageFieldValueStyleSet.margin)?item.styleSet.pageFieldValueStyleSet.margin.replace('px','')*1:5"></vue-qr>
                          </template>
                          <template v-else-if="(item.styleSet.showStyle==40)"> <!-- 条码组件 -->
                            <barcode :value="item.defaultValStr" :width="(item.styleSet.pageFieldValueStyleSet&&item.styleSet.pageFieldValueStyleSet.width)?item.styleSet.pageFieldValueStyleSet.width.replace('px','')*1:1" :height="(item.styleSet.pageFieldValueStyleSet&&item.styleSet.pageFieldValueStyleSet.height)?item.styleSet.pageFieldValueStyleSet.height.replace('px','')*1:50" :fontSize="(item.styleSet.pageFieldValueStyleSet&&item.styleSet.pageFieldValueStyleSet.fontSize)?item.styleSet.pageFieldValueStyleSet.fontSize:'0px'"></barcode>
                          </template>
                          <template v-else-if="(item.styleSet.showStyle==41)"> <!-- 盘点框 -->
                            <kw_utfc v-model="pageSetInfo.fieldSet[index]" :ref="('field_'+index)" :id="('field_'+index)" :nowDataId="(item.defaultCheckValue)" :filedIndex="item.prevFieldIndex+':'+item.nowFieldIndex+'-'+nowDataIndex" :pageSetInfo="pageSetInfo" :nowDataIndex="nowDataIndex+''" @dialogFieldCallBack="dialogFieldCallBack"  @getParentKwLook="getParentKwLook" @bindElementChange="bindElementChange" :isLimitButton="isLimitButton" :fieldSetindex="index"></kw_utfc>
                          </template>
                          <template v-else-if="(item.styleSet.showStyle==42)"> <!-- 扫码框 -->
                            <kw_scan_input v-model="pageSetInfo.fieldSet[index]" :nowDataId="(item.defaultCheckValue)" :filedIndex="item.prevFieldIndex+':'+item.nowFieldIndex+'-'+nowDataIndex" :pageSetInfo="pageSetInfo" :nowDataIndex="nowDataIndex+''" @dialogFieldCallBack="dialogFieldCallBack"  @getParentKwLook="getParentKwLook" @bindElementChange="bindElementChange" :isLimitButton="isLimitButton" :fieldSetindex="index"></kw_scan_input>
                          </template>
                          <template v-else-if="(item.styleSet.showStyle==43)"> <!-- 对象选择 -->
                            <OneFieldSet :fieldOne="{cnName:item.fieldCnName,enName:'defaultValStrJson',type:8}" v-model="pageSetInfo.fieldSet[index]" :ImageList="[]" @fieldValueChange="bindElementChange43(item,index)"></OneFieldSet>
                          </template>
                          <template v-else-if="(item.styleSet.showStyle==44)"> <!-- 多条件插件 -->
                            <el-button type="primary" @click="openShowStyle44(item,index)">设置条件</el-button>
                          </template>
                          <template v-else-if="(item.styleSet.showStyle==45)"> <!-- 知识图谱组件 -->
                            <kw_relation_graph :styleSet="item.styleSet" :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" :ifRefresh="pageSetInfo.ifRefresh" @getParentKwList=getParentKwList @getNowKwLook=getNowKwLook></kw_relation_graph>
                          </template>
                          <div v-else-if="(item.styleSet.showStyle==46)"> <!-- GIS遥感展示 -->
                            <kw_gis_show v-model="pageSetInfo.fieldSet[index]"  :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" :ifRefresh="pageSetInfo.ifRefresh" @getParentKwList=getParentKwList @getNowKwLook=getNowKwLook ></kw_gis_show>
                          </div>
                          
                        </el-col>
                        <template v-if="((!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1))">
                          <el-col v-for="middelOne in item.middelIndex" :key="'middelField_' + index + '_' + middelOne" :xs="(24/(maxRowColJson.maxCol+1))" :sm="(24/(maxRowColJson.maxCol+1))" v-show="!item.ifHide && (!item.styleSet || item.styleSet.showStyle!=7)" :md="(24/(maxRowColJson.maxCol+1))" :lg="(24/(maxRowColJson.maxCol+1))" :xl="(24/(maxRowColJson.maxCol+1))" :class="visitSource == 2?'forFieldDefaultNull':''" >
                            <div kwName="pageForFieldStyleSet" >
                              
                            </div>
                          </el-col>
                        </template>
                        <!--  -->
                        <el-col v-if="(ifChild==0 || visitSource == 3) && (item.childFieldSet && item.childFieldSet.length > 1 || item.addStyle==3) && (item.childPageJsonArr && item.childPageJsonArr.length > 0)" v-show="((!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1))" :key="'childPage_'+index" :span=24 >
                          <div v-if="visitSource==2" :ref="'childTitleRowBox_'+index" :style="(visitSource==2?'padding: 0 80px 0 22px;margin:10px 0 0 50px;':'padding: 0 10px 0 10px;margin:10px 0 0 20px;')+'position: relative;background:#fff;border: 1px solid green;width:-webkit-fill-available;overflow-x: hidden;'+ (item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:'')">
                            <el-row :gutter="10" style="display: inline-flex;margin-left: 5px;width: 100%;"  >
                              <template v-for="(childFieldOne,childFieldIndex) in item.childFieldSet">
                                <!-- style="display:table-cell;float:none;vertical-align: middle;" -->
                                <el-col v-if="childFieldOne.fieldRole != 30 && childFieldOne.childHeadHide!=1" style="min-width:150px;padding-left: 20px;" :key="'childHeadField_'+childFieldIndex" :xs="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :sm="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :md="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :lg="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :xl="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))"  v-show="!childFieldOne.ifHide">
                                  {{childFieldOne.fieldCnName}}
                                </el-col>
                              </template>
                            </el-row>
                          </div>
                          <div v-for="(childOne,childIndex) in item.childPageJsonArr" :key="'childLook_'+childIndex+'_' + childOne.updateDataId" :ref="'childDivBox_'+index + '_' + childIndex"
                              :style="(visitSource==2?'padding: 0 80px 0 22px;margin:10px 0 0 50px;':'padding: 0 10px 0 10px;margin:10px 0 0 20px;')+'position: relative;background:#fff;border: 1px solid green;overflow-x: auto;'+ (item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:'')" kwName="pageFieldStyleSet" @scroll="childLookHandleScroll(item,index,childIndex)" >
                            <span style="position: absolute;font-size: 12px;margin-right:5px;top:5px;left: 2px;color: red;">{{childIndex+1}}</span>
                            <kw_look :ref="('kw_look_'+item.fieldId + '_' + childIndex)" :class="('kw_look_'+item.fieldId)" :initMainId="childOne.updateDataId" :initPageSetInfo="childOne" :ifChild="1" @goBack="goBack"  @getParentKwLook="getParentKwLook"  :isLimitButton="isLimitButton"  :nowDataIndex="childIndex+''" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs"></kw_look>
                            <el-button-group style="position: absolute;top:5px;left : 10px;">
                              <el-button v-if="item.pxObject && item.pxObject.inputFName" type="primary" size="mini" icon="el-icon-top" style="padding: 1px 1px;" @click="toUpChildOne(item,childIndex)"></el-button>
                              <el-button v-if="item.pxObject && item.pxObject.inputFName" type="primary" size="mini" icon="el-icon-bottom" style="padding: 1px 1px;" @click="toDownChildOne(item,childIndex)"></el-button>
                              <el-button v-if="item.ifUpdate!=0" type="primary" size="mini" icon="el-icon-delete-solid" style="padding: 1px 1px;" @click="toDeleteChildOne(item,childIndex)"></el-button>
                            </el-button-group>
                          </div>
                        </el-col>
                      </template>
                    </template>
                  </el-row>
                  <template v-for="(item,index) in pageSetInfo.fieldSet" >
                    <el-row v-if="(ifChild==1 && visitSource==2) && (item.childFieldSet && item.childFieldSet.length > 1 || item.addStyle==3) && (item.childPageJsonArr && item.childPageJsonArr.length > 0)" :key="'child_lookField_'+index" type="flex" :gutter="10" :style="'margin-left:5px;margin-right:5px;' + (ifChild==1?'display: inline-flex;width: 100%;':'flex-wrap:wrap;') + 'background:'+ pageSetInfo.styleSet.lookBackground" v-show="!item.ifHide">
                        <el-col v-show="((!item.styleSet || !item.styleSet.showStyle || item.styleSet.showStyle==1))" :key="'childPage_'+index" :span=24 >
                          <div v-if="visitSource==2" :ref="'childTitleRowBox_'+index" :style="(visitSource==2?'padding: 0 80px 0 22px;margin:10px 0 0 50px;':'padding: 0 10px 0 10px;margin:10px 0 0 20px;')+'position: relative;background:#fff;border: 1px solid green;width:-webkit-fill-available;overflow-x: hidden;'+ (item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:'')">
                            <el-row :gutter="10" style="display: inline-flex;margin-left: 5px;width: 100%;"  >
                              <template v-for="(childFieldOne,childFieldIndex) in item.childFieldSet">
                                <el-col v-if="childFieldOne.fieldRole != 30 && childFieldOne.childHeadHide!=1" style="min-width:150px;padding-left: 20px;" :key="'childHeadField_'+childFieldIndex" :xs="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :sm="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :md="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :lg="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))" :xl="Math.ceil(childFieldOne.colSpan*(24/(item.childMaxCol+1)))"  v-show="!childFieldOne.ifHide">
                                  {{childFieldOne.fieldCnName}}
                                </el-col>
                              </template>
                            </el-row>
                          </div>
                          <div v-for="(childOne,childIndex) in item.childPageJsonArr" :key="'childLook_'+childIndex+'_'+childOne.defaultIdStr+'_'+childOne.updateDataId" :ref="'childDivBox_'+index + '_' + childIndex"
                              :style="(visitSource==2?'padding: 0 80px 0 22px;margin:10px 0 0 50px;':'padding: 0 10px 0 10px;margin:10px 0 0 20px;')+'position: relative;background:#fff;border: 1px solid green;overflow-x: auto;'+ (item.styleSet.pageFieldStyleSet?item.styleSet.pageFieldStyleSet.styleSetCode:'')" kwName="pageFieldStyleSet" @scroll="childLookHandleScroll(item,index,childIndex)" >
                            <span style="position: absolute;font-size: 12px;margin-right:5px;top:5px;left: 2px;color: red;">{{childIndex+1}}</span>
                            <kw_look :ref="('kw_look_'+item.fieldId + '_' + childIndex)" :class="('kw_look_'+item.fieldId)" :initMainId="childOne.updateDataId" :initPageSetInfo="childOne" :ifChild="1" @goBack="goBack"  @getParentKwLook="getParentKwLook"  :isLimitButton="isLimitButton"  :nowDataIndex="childIndex+''" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs"></kw_look>
                            <el-button-group style="position: absolute;top:5px;left : 10px;">
                              <el-button v-if="item.pxObject && item.pxObject.inputFName" type="primary" size="mini" icon="el-icon-top" style="padding: 1px 1px;" @click="toUpChildOne(item,childIndex)"></el-button>
                              <el-button v-if="item.pxObject && item.pxObject.inputFName" type="primary" size="mini" icon="el-icon-bottom" style="padding: 1px 1px;" @click="toDownChildOne(item,childIndex)"></el-button>
                              <el-button v-if="item.ifUpdate!=0" type="primary" size="mini" icon="el-icon-delete-solid" style="padding: 1px 1px;" @click="toDeleteChildOne(item,childIndex)"></el-button>
                            </el-button-group>
                          </div>
                        </el-col>
                    </el-row>
                  </template>
              </el-form>
            </div>
            <div v-if="((pageSetInfo.operaButtonSet && pageSetInfo.operaButtonSet.length > 0) ||(pageSetInfo.styleSet.updateButtonSet && pageSetInfo.styleSet.updateButtonSet.length > 0))" :class="((buttonCssStyle && buttonCssStyle) != 6?'ButtonBlock':'')" >
              <template v-for="(buttonItem,buttonIndex) in pageSetInfo.operaButtonSet">
                <div :key="'opera_'+buttonIndex" v-if="(buttonItem.styleSet.cssStyle==6) && (buttonItem.ifShow && (dataInfo[buttonItem.butTjKey] != 0))">
                  <!-- 提交订单栏 -->
                  <div :style="'float:left;'+ (buttonItem.styleSet.buttonSetButtonStyleSet?buttonItem.styleSet.buttonSetButtonStyleSet.styleSetCode:'')" kwName="buttonSetButtonStyleSet" class="listButton" :class="buttonItem.styleSet.buttonSetButtonStyleSet?buttonItem.styleSet.buttonSetButtonStyleSet.defineHover : ' '" :data-buttonindex="buttonIndex" @click="dataButtonClick(buttonItem)">{{buttonItem.buttonName}}</div>
                </div>
              </template>
              <!-- 添加修改页面的 保存和取消按钮 -->
              <template v-for="(buttonItem,buttonIndex) in pageSetInfo.styleSet.updateButtonSet">
                <!-- 提交订单栏 -->
                <div :key="'saveBut_'+buttonIndex" v-if="(buttonItem.cssStyle==6)" :style="'float:left;'+ (buttonItem.buttonSetButtonStyleSet?buttonItem.buttonSetButtonStyleSet.styleSetCode:'')" kwName="buttonSetButtonStyleSet" class="listButton" :class="buttonItem.cssBgPosition==2?'positionRightBottom':buttonItem.cssBgPosition==3?'positionLeftBottom':''"  :data-buttonindex="buttonIndex" @click="saveAddOrUpdate(buttonItem)">{{buttonItem.buttonName}}</div>
              </template>
            </div>
            <!-- 主标题下按钮 -->
            <kw_btn_array :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" @dataButtonClick="dataButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :showCssStyle="7"></kw_btn_array>
          </div>
        </el-col>
      </el-row>

      <!-- 审批流程的显示和处理 -->
      <el-steps style="margin:0 40px;" v-if="pageSetInfo.ifAddCheckFlow == 1" :active="checkFlowNowFloor" :direction="visitSource==2?'horizontal':'vertical'" >
        <template v-for="(checkFlowOne,checkFlowindex) in checkFlowFloorList" >
          <el-step v-if="checkFlowOne" :key="'checkFlow_'+checkFlowindex" :title="checkFlowOne.FLOOR_NAME?checkFlowOne.FLOOR_NAME:('第' + (checkFlowindex+1) + '层')" >
            <div slot="description" :style="visitSource==2?'width:300px;':''" >
              <div>
                  <!-- <el-select :style="checkFlowOne.ifSave?'border: 1px solid rgb(255, 113, 27);':''" v-model="checkFlowOne.CHECK_STATE" :disabled="checkFlowOne.ifSave?false:true" placeholder="选择审核状态" style="width:100%" >
                    <el-option label="审批通过" :value="1"></el-option>
                    <el-option label="审批不通过" :value="2"></el-option>
                  </el-select> -->
                  <el-radio-group v-model="checkFlowOne.CHECK_STATE" :disabled="checkFlowOne.ifSave?false:true" :style="'padding: 10px 0px;width: 100%;' + (checkFlowOne.ifSave?'border: 1px solid rgb(255, 113, 27);':'')">
                    <el-radio :label="1">审批通过</el-radio>
                    <el-radio :label="2">审批不通过</el-radio>
                  </el-radio-group>
              </div>
              <div>
                <el-input prefix-icon="el-icon-date" disabled v-model="checkFlowOne.CHECK_TIME" placeholder="默认当前时间"></el-input>
              </div>
              <div>
                <el-input  prefix-icon="el-icon-user" disabled v-model="checkFlowOne.CHECK_USER" placeholder="审核人"></el-input>
              </div>
              <div>
                <el-input :style="checkFlowOne.ifSave?'border: 1px solid rgb(255, 113, 27);':''" prefix-icon="el-icon-document" :disabled="checkFlowOne.ifSave?false:true" v-model="checkFlowOne.REMARK" placeholder="审核备注"></el-input>
              </div>
            </div>
          </el-step>
        </template>
      </el-steps>
      
      <!-- 循环一遍 非左右结构 和非选项卡的  -->
      <template v-for="(item,index) in pageSetInfo.tabPageSet" >
          <div :key="'tabPage_'+index" v-if="(item.styleSet.jumpWay != 3 && item.styleSet.jumpWay != 4 && item.styleSet.jumpWay != 5 && item.styleSet.jumpWay != 6 && item.styleSet.jumpWay != 7 &&(dataInfo['BLOCK_SHOW_'+item.tabPageId] != 0))" :style="item.styleSet.tabPageForBoxStyleSet?item.styleSet.tabPageForBoxStyleSet.styleSetCode:''" kwName="tabPageForBoxStyleSet">
            <!-- 判断显示条件设置 -->
            <el-row  type="flex" justify="center">
              <el-col :xs="24" :sm="24" :md="24" :lg="item.styleSet.tabScreenLg?item.styleSet.tabScreenLg*1:(pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24)" :xl="item.styleSet.tabScreenXl?item.styleSet.tabScreenXl*1:(pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24)">
                <div  >
                  <div v-if="(item.styleSet.jumpWay == 2 || item.styleSet.setHeaderHide != 1)" class="curriculumTitle_pc" :style="(item.styleSet.lookTileTabsCommonStyleSet&&item.styleSet.lookTileTabsCommonStyleSet.styleSetCode)?item.styleSet.lookTileTabsCommonStyleSet.styleSetCode:(pageSetInfo.styleSet.lookTileTabsCommonStyleSet?pageSetInfo.styleSet.lookTileTabsCommonStyleSet.styleSetCode:'')" kwName="lookTileTabsCommonStyleSet">
                    <div :style="item.styleSet.tabPageFieldStyleSet?item.styleSet.tabPageFieldStyleSet.styleSetCode:''" kwName="tabPageFieldStyleSet">
                      <template style="" v-if="(item.styleSet.setHeaderHide != 1)">
                        <img v-if="(item.styleSet.titleIcon == 2)" :src="(item.styleSet.titBgImage?GLOBAL.getFileServeUrl()+item.styleSet.titBgImage:'./img/oneself.png')" class="titleBtnImg" :style="'vertical-align: middle;'+ (item.styleSet.tabPageFieldIconStyleSet?item.styleSet.tabPageFieldIconStyleSet.styleSetCode:'')" kwName="tabPageFieldIconStyleSet"/>
                        <div :class="(item.styleSet.titleIcon != 2?'tabname_pc':'')" :style="'display:inline-block;'+(item.styleSet.tabPageFieldNameStyleSet?item.styleSet.tabPageFieldNameStyleSet.styleSetCode:'')" kwName="tabPageFieldNameStyleSet">{{item.tabName+((item.styleSet.ifShowTotal==1 || (pageSetInfo.styleSet.ifShowTotal==1&&item.styleSet.ifShowTotal!=2))?'('+(item.dataTotal>=0?item.dataTotal:'0')+')':'')}}</div>
                      </template>
                      <div v-if="(item.styleSet.jumpWay == 2)" @click="tabPageToList(item)" class="loadmore" :style="'display: inline-block;'+(item.styleSet.tabPageFieldValueStyleSet?item.styleSet.tabPageFieldValueStyleSet.styleSetCode:'')" kwName="tabPageFieldValueStyleSet">{{pageSetInfo.styleSet.titleHide?pageSetInfo.styleSet.titleHide:'全部'}}</div>
                    </div>
                  </div>
                  <kw_list v-if="(item.type==1)" :ref="'kw_list_'+index" :id="('kw_list_'+index)" :initPageObj="item" :mainId="mainId" :parentTabIndex="(index)" :ifShowSearch="item.ifShowSearch" @zdyParentEvent="zdyParentEvent" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook"></kw_list>
                  <kw_look v-else-if="(item.type==11 || item.type==7 || item.type==5)" :ref="'tabPageSet_kw_look_'+index" :pageInfo="item" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs"></kw_look>
                </div>
              </el-col>
            </el-row>
          </div>
      </template>
      <!-- 结束 -->
      <!-- 关联选项卡的内容 -->
      <div class="MiddleScoreBox" :style="'background:'+pageSetInfo.styleSet.listBackground">
        <!-- 循环判断是否有选项卡展现形式的标签 如果有的话加载 -->
        <el-row type="flex" justify="center">
          <el-col :xs="24" :sm="24" :md="24" :lg="pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24" :xl="pageSetInfo.styleSet.rotationChartScreenXl?pageSetInfo.styleSet.rotationChartScreenXl*1:24">
            <div class="clearfix">
              <div :class="pageSetInfo.styleSet.specialTabDistinguish == 1?'floatLeft tabLeftWidth bottomBlockDistance':''">
                <div ref="searchBar"  v-if="(pageSetInfo.styleSet.tabStyle && pageSetInfo.styleSet.tabStyle==2)" class="tabsBox_pc" :class="(pageSetInfo.styleSet.titleHide?'tabsBox ':'')+(pageSetInfo.styleSet.ifShowBottomLine==1?'botLine':'')+' '+(pageSetInfo.styleSet.newTabLine=='paihang'?'tabbg':'')"  :style="pageSetInfo.styleSet.lookTabsBoxCommonStyleSet?pageSetInfo.styleSet.lookTabsBoxCommonStyleSet.styleSetCode:''" kwName="lookTabsBoxCommonStyleSet">
                  <div class="customTitle_pc" v-if="(pageSetInfo.styleSet.titleHide)" :style="pageSetInfo.styleSet.lookTabTitleCommonStyleSet?pageSetInfo.styleSet.lookTabTitleCommonStyleSet.styleSetCode:''" kwName="lookTabTitleCommonStyleSet">{{pageSetInfo.styleSet.titleHide}}</div>
                  <kw_tabs :class="searchBarFixed == true && pageSetInfo.styleSet.setSticky == 2  ? 'isFixed' :''" :style="'overflow: auto;width:'+pageSetInfo.styleSet.titleHide?'':' 100%'" :type="(pageSetInfo.styleSet.newTabLine=='paihang'?'tabbg':'')" v-model="(tabCurrent)" @tab-click="pageTabchange" :scroll="true" :tabsStyleSet="pageSetInfo.styleSet.lookTabsCommonStyleSet?pageSetInfo.styleSet.lookTabsCommonStyleSet.styleSetCode:''" kwName="lookTabsCommonStyleSet">
                    <!-- 判断显示条件设置 -->
                    <kw_tab v-for="(item,index) in pageSetInfo.tabPageSet" :key="'tabPage_'+index"  v-if="((dataInfo['BLOCK_SHOW_'+item.tabPageId] != 0) && item.styleSet.jumpWay ==4)" :name="index" :title="(item.tabName+((item.styleSet.ifShowTotal==1 || (pageSetInfo.styleSet.ifShowTotal==1&&item.styleSet.ifShowTotal!=2))?'('+(item.dataTotal>=0?item.dataTotal:'0')+')':''))" :type="item.styleSet.newTabLine?item.styleSet.newTabLine:pageSetInfo.styleSet.newTabLine" :tabBoxStyle="pageSetInfo.styleSet.lookTabCommonStyleSet?pageSetInfo.styleSet.lookTabCommonStyleSet.styleSetCode:''" :tabDefaultStyle="(item.styleSet.lookTabChildDefaultCommonStyleSet && item.styleSet.lookTabChildDefaultCommonStyleSet.styleSetCode)?item.styleSet.lookTabChildDefaultCommonStyleSet.styleSetCode:((item.lookTabChildDefaultCommonStyleSet && item.lookTabChildDefaultCommonStyleSet.styleSetCode)?item.lookTabChildDefaultCommonStyleSet.styleSetCode:(pageSetInfo.styleSet.lookTabDefaultCommonStyleSet?pageSetInfo.styleSet.lookTabDefaultCommonStyleSet.styleSetCode:''))" :tabCheckStyle="(item.styleSet.lookTabChildCheckCommonStyleSet&&item.styleSet.lookTabChildCheckCommonStyleSet.styleSetCode)?item.styleSet.lookTabChildCheckCommonStyleSet.styleSetCode:((item.lookTabChildCheckCommonStyleSet&&item.lookTabChildCheckCommonStyleSet.styleSetCode)?item.lookTabChildCheckCommonStyleSet.styleSetCode:(pageSetInfo.styleSet.lookTabCheckCommonStyleSet?pageSetInfo.styleSet.lookTabCheckCommonStyleSet.styleSetCode:''))" :definehover="pageSetInfo.styleSet.lookTabsBoxCommonStyleSet?pageSetInfo.styleSet.lookTabsBoxCommonStyleSet.defineHover:' '" kwName="lookTabCommonStyleSet"></kw_tab>
                  </kw_tabs>
                </div>
                <!-- 首页标准结构 -->
                <template v-for="(item,index) in pageSetInfo.tabPageSet" >
                    <!-- 判断显示条件设置 -->
                  <template v-if="(dataInfo['BLOCK_SHOW_'+item.tabPageId] != 0)">
                    <template v-if="(pageSetInfo.styleSet.tabStyle &&  pageSetInfo.styleSet.tabStyle==2 && item.styleSet.jumpWay == 4)" >
                      <!-- v-if="(tabCurrent == index) || !item.hasLoad"  -->
                      <div v-show="!(tabCurrent != index)" :key="'tabPage_'+'_'+index + (tabCurrent == index?('_'+tabCurrent):'')" >
                        <div v-if="(item.styleSet.setHeaderHide == 2 || item.styleSet.jumpWay == 2)" class="curriculumTitle" :style="item.styleSet.tabPageFieldStyleSet?item.styleSet.tabPageFieldStyleSet.styleSetCode:''" kwName="tabPageFieldStyleSet">
                          <div :style="item.styleSet.tabPageFieldNameStyleSet?item.styleSet.tabPageFieldNameStyleSet.styleSetCode:''" kwName="tabPageFieldNameStyleSet" :class="(pageSetInfo.styleSet.titleStyle && pageSetInfo.styleSet.titleStyle == 2?'tabname_pc':'' )+' '+(item.styleSet.titBgImage?'tabTitPos':'')" v-if="(item.styleSet.setHeaderHide == 2)">{{item.tabName+((item.styleSet.ifShowTotal==1 || (pageSetInfo.styleSet.ifShowTotal==1&&item.styleSet.ifShowTotal!=2))?'('+(item.dataTotal>=0?item.dataTotal:'0')+')':'')}}</div>
                          <span class="rightTit" v-if="(item.styleSet.jumpWay == 2)" @click="tabPageToList(item)" :style="item.styleSet.tabPageFieldValueStyleSet?item.styleSet.tabPageFieldValueStyleSet.styleSetCode:''" kwName="tabPageFieldValueStyleSet">{{pageSetInfo.styleSet.titleHide?pageSetInfo.styleSet.titleHide:'全部'}}</span>
                        </div>
                        <kw_list v-if="(item.type==1)" :ref="('kw_list_'+index)" :id="('kw_list_'+index)" :initPageObj="(item)" :mainId="(mainId)" :parentTabIndex="(index)" :ifShowSearch="item.ifShowSearch" @zdyParentEvent="zdyParentEvent" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook"></kw_list>
                       
                        <kw_look v-else-if="(item.type==11 || item.type==7 || item.type==5)" :ref="'tabPageSet_kw_look_'+index" :pageInfo="(item)" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs"></kw_look>
                      </div>
                    </template>
                  </template>
                </template>
              </div>
              <!-- PC端 右侧显示类型 -->
              <template v-for="(item,index) in pageSetInfo.tabPageSet">
                <div :key="'tabPageRight_'+index" v-if="item.styleSet.jumpWay ==6 && (dataInfo['BLOCK_SHOW_'+item.tabPageId] != 0)" class="floatRight tabRightWidth bottomBlockDistance" style="background: #fff;padding: 10px;min-height: 500px">
                  <div v-if="(item.styleSet.jumpWay == 2 || item.styleSet.setHeaderHide != 1)" :class="(pageSetInfo.styleSet.titleStyle && pageSetInfo.styleSet.titleStyle == 2?'ExaminationCurriculumTitle':pageSetInfo.styleSet.titleStyle == 3? 'curriculumTitleBg' :'curriculumTitle_pc' )" :style="'border:'+(item.styleSet.titleBorder)+';margin:'+(item.styleSet.titleMargin)+';padding:'+(item.styleSet.titlePadding)+';background:'+(item.styleSet.titleBgColor)+'font-size:'+item.styleSet.titleFontSize">
                    <div :style="item.styleSet.jumpWay ==2?'display: flex;align-items: center;justify-content: space-between;':''">
                      <div style="display:inline-block" v-if="(item.styleSet.setHeaderHide != 1)">
                        <img v-if="(item.styleSet.titleIcon == 2)" :src="(item.styleSet.titBgImage?GLOBAL.getFileServeUrl()+item.styleSet.titBgImage:'./img/oneself.png')" class="titleBtnImg" style="vertical-align: middle;"/>
                        <span :class="(item.styleSet.titleIcon != 2?'tabname_pc':'')" :style="item.styleSet.tabPageFieldNameStyleSet?item.styleSet.tabPageFieldNameStyleSet.styleSetCode:''" kwName="tabPageFieldNameStyleSet">{{item.tabName+((item.styleSet.ifShowTotal==1 || (pageSetInfo.styleSet.ifShowTotal==1&&item.styleSet.ifShowTotal!=2))?'('+(item.dataTotal>=0?item.dataTotal:'0')+')':'')}}</span>
                      </div>
                      <span v-if="(item.styleSet.jumpWay == 2)" @click="tabPageToList(item)" class="loadmore" :style="item.styleSet.tabPageFieldValueStyleSet?item.styleSet.tabPageFieldValueStyleSet.styleSetCode:''" kwName="tabPageFieldValueStyleSet">{{pageSetInfo.styleSet.titleHide?pageSetInfo.styleSet.titleHide:'全部'}}</span>
                    </div>
                  </div>
                  <kw_list v-if="(item.type==1)" :ref="('kw_list_'+index)" :id="('kw_list_'+index)" :initPageObj="(item)" :mainId="(mainId)" :parentTabIndex="(index)"  :ifShowSearch="item.ifShowSearch" @zdyParentEvent="zdyParentEvent" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook"></kw_list>
                  <kw_look v-else-if="(item.type==11 || item.type==7 || item.type==5)" :ref="'tabPageSet_kw_look_'+index" :pageInfo="(item)" @goBack="goBack" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" @getParentKwLook="getParentKwLook" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs"></kw_look>
                </div>
              </template>
            </div>
          </el-col>
        </el-row>
      </div>

      
    </div>

    <!-- 按钮 -->
    <el-row type="flex" justify="center" class="noPrint">
      <el-col :xs="24" :sm="24" :md="24" :lg="pageSetInfo.styleSet.rotationChartScreenLg?pageSetInfo.styleSet.rotationChartScreenLg*1:24" :xl="pageSetInfo.styleSet.rotationChartScreenXl?pageSetInfo.styleSet.rotationChartScreenXl*1:24">
        <!-- 我已同意复选框 -->
        <div v-if="(dataInfo.PREV_SAVE_FILE && dataInfo.PREV_SAVE_FILE.length > 0)" class="prevSaveChecked">
          <el-checkbox v-model="prevSaveChecked">我已同意全部合同协议</el-checkbox>
          <button type="button" @click="toOpenFile" class="prevSaveCheckedBtn">
            《合同协议》
          </button>
        </div>
        
        <kw_btn_array v-if="(pageSetInfo.operaButtonSet && pageSetInfo.operaButtonSet.length > 0)" :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" @dataButtonClick="dataButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :showCssStyle="1"></kw_btn_array>
        <!-- 按钮 -->
        <kw_btn_array v-if="(pageSetInfo.styleSet.updateButtonSet && pageSetInfo.styleSet.updateButtonSet.length > 0)" :pageSetInfo="pageSetInfo" :dataInfo="dataInfo" @dataButtonClick="saveAddOrUpdate" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :showCssStyle="1" type="updateButtonSet"></kw_btn_array>
          <!-- 添加修改页面的 保存和取消按钮 -->
        <!-- <div v-if="((pageSetInfo.styleSet.updateButtonSet &z& pageSetInfo.styleSet.updateButtonSet.length > 0))" :class="((buttonCssStyle && buttonCssStyle) != 6?'ButtonBlock':'')">
          <div v-for="(buttonItem,buttonIndex) in pageSetInfo.styleSet.updateButtonSet" :key="'saveBut_'+buttonIndex">
            <div v-if="(buttonItem.cssStyle==1)"  :style="buttonItem.buttonSetButtonStyleSet?buttonItem.buttonSetButtonStyleSet.styleSetCode:''" kwName="buttonSetButtonStyleSet" class="listButton" :class="buttonItem.cssBgPosition==2?'positionRightBottom':buttonItem.cssBgPosition==3?'positionLeftBottom':''"  :data-buttonindex="buttonIndex" @click="saveAddOrUpdate(buttonItem)">{{buttonItem.buttonName}}</div>
          </div>
        </div> -->
      </el-col>
    </el-row>

    <!-- 页面浮动按钮 -->
    <div v-for="(buttonItem,buttonIndex) in pageSetInfo.operaButtonSet" :key="'floorBut_'+buttonIndex" >
      <div v-if="buttonItem.ifShow && (dataInfo[buttonItem.butTjKey] != 0) && buttonItem.styleSet.cssStyle==8"  >
        <span :data-buttonindex="buttonIndex" @click="dataButtonClick(buttonItem)" class="suspensionBtn" :style="buttonItem.styleSet.buttonSetButtonStyleSet?buttonItem.styleSet.buttonSetButtonStyleSet.styleSetCode:''" kwName="buttonSetButtonStyleSet">
          {{buttonItem.buttonName}}
        </span>
      </div>
    </div>

    <!-- 支付的二维码页面 -->
    <el-dialog
      title="提示"
      :visible.sync="wxPayCodeDialogJson.flag"
      width="70%">
      <div class="newPayBox">
        <div class="apply_up" v-if="wxPayCodeDialogJson.PAY_WAY==2">
          <h2 style="padding-top: 1rem">请支付宝扫码支付</h2>
          <!-- 二维码组件 -->
          <vue-qr  :text="wxPayCodeDialogJson.img_src" :size="200" :margin="5"></vue-qr>
          <p style="margin: 0;padding: 1rem 0">金额:<span class="money" style="color: #E70012">{{wxPayCodeDialogJson.total_fee/100}}</span></p>
        </div>
        <div class="apply_up" v-else-if="wxPayCodeDialogJson.PAY_WAY==3">
          <h2 style="padding-top: 1rem">请使用POS机扫码支付</h2>
          <!-- 二维码组件 -->
          <vue-qr  :text="wxPayCodeDialogJson.img_src" :size="200" :margin="5"></vue-qr>
          <p style="margin: 0;padding: 1rem 0">金额:<span class="money" style="color: #E70012">{{wxPayCodeDialogJson.total_fee/100}}</span></p>
        </div>
        <div class="apply_up" v-else>
          <h2 style="padding-top: 1rem">请微信扫码支付</h2>
          <img :src="GLOBAL.baseURL+'qrCode/'+wxPayCodeDialogJson.img_src" ><img>
          <p style="margin: 0;padding: 1rem 0">金额:<span class="money" style="color: #E70012">{{wxPayCodeDialogJson.total_fee/100}}</span></p>
        </div>
      </div>
    </el-dialog>
    <!-- 弹出层组件 -->
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="100%" top="1vh" center append-to-body :close-on-click-modal="false" v-dialogDrag>
      <template slot="title"> 
          <div>
            {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
          </div>    
      </template>
      <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
      <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton" :initCustomVueJs="initCustomVueJs?initCustomVueJs:pageSetInfo.customVueJs" :ifDialog="1"></kw_look>
      <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-210) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
      <span slot="footer" v-if="dialogInfo.type==999">
        <el-button @click="dialogIframeZdyCancel">取 消</el-button>
        <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 文件预览组件 -->
    <el-dialog class="zdy_dialog" :modal="true" v-if="filePreviewInfo.ifLoad" v-show="filePreviewInfo.ifShow" :title="filePreviewInfo.name" :visible.sync="filePreviewInfo.ifLoad" width="100%" top="1vh" center append-to-body v-dialogDrag>
      <kw_file_preview v-model="filePreviewInfo" ></kw_file_preview>
    </el-dialog>
    <el-dialog title="安装打印组件" v-if="printDialogInfo" :visible.sync="printDialogInfo" width="50%" top="20vh" center append-to-body>
      <el-row justify="center">
        <el-col :span="24" style="text-align:center;">
          请先安装浏览器打印服务
          <div><a :href="GLOBAL.baseURL+'CLodop_Setup_for_Win32NT.exe'" download="CLodop_Setup_for_Win32NT.exe">web打印服务</a></div>
          请下载并安装打印控件,然后重新打印
          <div><a :href="GLOBAL.baseURL+'install_lodop64.exe'" download="install_lodop64.exe">64位下载</a></div>
          <div><a :href="GLOBAL.baseURL+'install_lodop32.exe'" download="install_lodop32.exe">32位下载</a></div>
        </el-col>
      </el-row>

    </el-dialog>

    <!-- <button :id="'kw_print_hidden_button_' + pageId" style="display:none;" type='button'  v-print="{id:'#print_kw_box_'+pageId,popTitle: '打印'}">打印</button> -->
    
    <!-- 打开页面设置按钮 -->
    <div v-if="loginInfo.USERID == 0" style="position: absolute;right: 0;bottom: 0px;z-index:999999;opacity: 0.5;">
      <el-button @click="toOpenPageSet(1)" style="" title="小程序样式设置" icon="el-icon-mobile-phone" type='primary' ></el-button>
      <el-button @click="toOpenPageSet(2)" style="" title="PC样式设置" icon="el-icon-s-platform" type='primary' ></el-button>
    </div>  
    <!-- 多条件插件弹出层 -->
    <el-dialog class="zdy_dialog" :modal="false" v-if="tjPlugDialogInfo.ifLoad" title="设置条件" :visible.sync="tjPlugDialogInfo.ifLoad" width="100%" top="1vh" center append-to-body v-dialogDrag>
      <PageBasicSet v-model="pageSetInfo.fieldSet[tjPlugDialogInfo.fieldIndex]" :tableId="tjPlugDialogInfo.tableId" :relationTableId="tjPlugDialogInfo.tableId" :ImageList="[]"  :basicBlockArr="tjPlugDialogInfo.blockArr" :cssBlockArr="[]"></PageBasicSet>
      <span slot="footer">
        <el-button @click="closeShowStyle44">取 消</el-button>
        <el-button type="primary" @click="confirmShowStyle44">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else>
    <!-- v-if="visitSource == 2" -->
    <div style="display: flex;justify-content: center;padding: 10px 0">
      <i class="el-icon-loading"></i>
    </div>
    <!-- <div v-else>页面加载中!</div> -->
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import printJS from 'print-js'

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
// import {getLodop} from '@/js/utils/LodopFuncs.js';
import WxValidate from '@/js/page/WxValidate.js';
export default {
  name: 'kw_look',
  props: {
    // 修改或查看的主键
    initMainId:{
      type:Number,
      default:0
    },
    // 页面信息
    pageInfo :{
      type:Object,
      default:null
    },
    // 初始的页面设置信息
    initPageSetInfo:{
      type: Object,
      default: null 
    },
    //自定义的js
    initCustomVueJs:{
      type: String,
      default:null
    },
    // 暂时无用
    initDataInfo: {
      type: Object,
      default: null
    },
    // 暂时无用
    nowDataIndex:{
      type: String,
      default: ''
    },
    ifChild:{
      type: Number,
      default: 0
    },
    //是否是预览组件 如果为1则为预览组件
    isPreview:{
      type: Number,
      default: 0
    },
    //预览的页面设置信息
    previewPageSetInfo:{
      type:Object,
      default:function(){return {}}
    },
    //预览的数据信息
    previewPageDataInfo:{
      type:Object,
      default:function(){return {}}
    },
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    },
    //是否是子级的试题添加页面 父级试题的相关信息
    parentQuestionInfo:{
      type:Object,
      default:()=>{
        return {};
      }
    },
    ifDialog:{
      type:Number,
      default:0
    }
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      windowHeight:window.innerHeight,
      //      是否吸顶
      searchBarFixed:false,
//      吸顶元素距离顶部高度
      tabTopHeight:0,
      //页面Id
      pageId: 0,
      tableId: 0,
      pageType: 11,
      listTableId: 0,
      mainId: 0,
      //页面设置信息
      pageSetInfo: {},
      maxRowColJson:{
        maxRow:0,
        maxCol:0,
        maxNum:0
      },
      fieldTableInfo:{
        row:0,
        col:0,
        rowColSpanInfo:{

        },
      },
      //页面的数据信息
      dataInfo: {},
      // 关联数据如果展现形式为选项卡时 选中的选项卡
      tabCurrent:0,
      refreshPrevTabCurrent:0,
      //数据按钮样式 当为6时要计算页面高度 定位到底部
      buttonCssStyle:0,
      //阅读同意复选框
      prevSaveChecked: false,
      // 右上角按钮组按钮
      actionSheetArr:[],
      actionSheetArrFlag:false,
      // 是否显示加载中的状态
      isLoading:false,
      // 是否已经加载完数据 可以显示组件
      hasLoad:false,
      // 校验插件
      WxValidate:null,
      checkPaySuccessTimer:null,
      // 微信PC支付时 放置支付二维码的弹出页面
      wxPayCodeDialogJson:{
        flag : false,
        img_src:"",
        total_fee:0
      },
      // 当为1时  页面加载后 自动打开微信支付
      wxPayState:0,
      // 微信支付的CODE参数
      wxPayCode:"",

      //发送验证码按钮的文字
      yzmText:"发送验证码",
      //发送验证码按钮的状态
      yzmFlag:false,
      // 填写的验证码
      yzmCode:"",
      //验证码倒计时
      auth_time:0,
      //短信验证码的ID
      registerId:0,
      //短信验证码的手机号
      registerPhone:"",
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
        ifLoad:false
      },
      /**
       * 文件预览组件的信息
       */
      filePreviewInfo:{
        name:'文件预览',
        ifLoad:false,
        ifShow:false
      },
      /**
       * 多条件插件组件信息
       */
      tjPlugDialogInfo:{
        ifLoad:false,
        fieldInfo:{},
        fieldIndex:-1,
        tableId:0,
        blockArr:[{
          blockCnName:"默认过滤",
          blockType:2,
          blockEnName:"childPageJsonArr44",
          fieldArr:[{
            cnName:"条件插件",enName:"tjIdJson",type:6,placeholder:''
          }]
        }]
      },
      /**
       * 是否是flutter环境打开
       */
      ifFlutterOpen:false,
      /**
       * 审批流程池节点数据
       */
      checkFlowFloorList:[],
      checkFlowNowFloor:0,
      loginInfo:{},
      //按照打印组件
      printDialogInfo:false,
      /**
       * UEditor 简单版样式
       */
      UEditorSampleConfig:{
        toolbars: [['fullscreen', 'source', '|',
            'undo', 'redo', '|',
            'bold', 'italic', 'underline',
            'forecolor', 'backcolor',  '|',
            'paragraph', 'fontfamily', 'fontsize', '|',
            'kityformula'
        ]]
      },
    };
  },
  created() {
    var that = this;
    // console.log("nowDataIndex==========================",this.nowDataIndex);
    window.flutterSuccessFile = (newFileList,fieldIndex) => {
      that.flutterSuccessFile(newFileList,fieldIndex);
    }
    this.initAtiached();
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  
  beforeRouteEnter (to, from, next) {
    let agent = navigator.userAgent
    const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if(isiOS) {
      localStorage.setItem('originUrl', location.href)  // 用于ios分享
    }
    next()
  },
  beforeDestroy(){
    clearInterval(this.checkPaySuccessTimer);
  },
  watch:{
    initPageSetInfo: function(){
      if (this.initPageSetInfo != null) { 
        // var pageSetInfo = this.initPageSetInfo;
        // pageSetInfo.styleSet = pageSetInfo.childStyleSet?pageSetInfo.childStyleSet:{};
        // this.pageSetInfo = pageSetInfo;
        // this.dataInfo = pageSetInfo.dataInfo;
        //console.log("子页面进行了渲染--------------------");
        this.initAtiached();
      }
    },
    previewPageSetInfo:{
      handler(newVal){
        this.previewInitLoad();
      },
      deep: true,
      immediate: true
    },
    previewPageDataInfo:function(newVal){
      this.previewInitLoad();
    },
    previewVisitSource:function(newVal){
      this.previewInitLoad();
    }
  },
  computed:{
  },
  components: {
    kw_information_card:resolve => require(['@/components/look/kw_information_card.vue'], resolve),
    // 弹出层组件
    kw_dialog_field:resolve => require(['@/components/look/kw_dialog_field.vue'], resolve),
    // 轮播图组件
    kw_carousel:resolve => require(['@/components/look/kw_carousel.vue'], resolve),
    // 人员头像列表组件 
    kw_avatar:resolve => require(['@/components/look/kw_avatar.vue'], resolve),
    // 勋章列表组件 kw_medal
    kw_medal:resolve => require(['@/components/look/kw_medal.vue'], resolve),
    // 图片预览组件 kw_preview_image
    kw_preview_image:resolve => require(['@/components/look/kw_preview_image.vue'], resolve),
    // 状态聚合组件 
    kw_having_view:resolve => require(['@/components/look/kw_having_view.vue'], resolve),
    // 两级选项卡 点击跳转组件 
    kw_label_col:resolve => require(['@/components/look/kw_label_col.vue'], resolve),
    // 切换组件 点击打开列表页面 
    kw_change_look:resolve => require(['@/components/look/kw_change_look.vue'], resolve),
    // 查看页面 双层行标签组件
    kw_label_row:resolve => require(['@/components/look/kw_label_row.vue'], resolve),
    // kw_tabs 标签组组件
    kw_tabs:resolve => require(['@/components/kw/kw_tabs.vue'], resolve),
    // kw_tab 标签组件
    kw_tab:resolve => require(['@/components/kw/kw_tab.vue'], resolve),
    // kw_submit_bar  提交组件
    kw_submit_bar:resolve => require(['@/components/kw/kw_submit_bar.vue'], resolve),
    // 倒计时
    kw_count_down:resolve => require(['@/components/form/kw_count_down.vue'], resolve),
    // 音频组件
    kw_audio:resolve => require(['@/components/form/kw_audio.vue'], resolve),
    // 视频组件
    kw_video:resolve => require(['@/components/form/kw_video.vue'], resolve),
    //角色看板组件
    kw_data_console:resolve => require(['@/components/form/kw_data_console.vue'], resolve),
    //角色栏目组件
    kw_menu:resolve => require(['@/components/form/kw_menu.vue'], resolve),
    // 图片定位组件
    kw_location_image:resolve => require(['@/components/look/kw_location_image.vue'], resolve),
    // 地址选择组件(百度地图)
    kw_map_drawing:resolve => require(['@/components/form/kw_map_drawing.vue'], resolve),
    // 地址选择组件(高德地图)
    kw_map_amap:resolve => require(['@/components/form/kw_map_amap.vue'], resolve),
    // 地址选择组件(gis地图天地图)
    kw_gis:resolve => require(['@/components/form/kw_gis.vue'], resolve),
    //  GIS遥感展示
    kw_gis_show:resolve => require(['@/components/form/kw_gis_show.vue'], resolve),
    // 排课组件
    kw_make_schedule:resolve => require(['@/components/kw/kw_make_schedule.vue'], resolve),
    // 工作台组件
    kw_work_plat:resolve => require(['@/components/look/kw_work_plat.vue'], resolve),
    // 周排课组件
    kw_make_week:resolve => require(['@/components/kw/kw_make_week.vue'], resolve),
    // 图片组件
    kw_icon:resolve => require(['@/components/kw/kw_icon.vue'], resolve),
    // 按钮组组件
    kw_btn_array:resolve => require(['@/components/look/kw_btn_array.vue'], resolve),
    // 文件预览组件
    kw_file_preview:resolve => require(['@/components/kw/kw_file_preview.vue'], resolve),
    // 试题组件
    Question:resolve => require(['@/components/exam/Question.vue'], resolve),
    // 360度图片预览
    kw_sphere_image:resolve => require(['@/components/look/kw_sphere_image.vue'], resolve),
    // 知识图谱组件
    kw_relation_graph:resolve => require(['@/components/look/kw_relation_graph.vue'], resolve),
    //盘点组件
    kw_utfc:resolve => require(['@/components/look/kw_utfc.vue'], resolve),
    //扫码组件
    kw_scan_input:resolve => require(['@/components/look/kw_scan_input.vue'], resolve),
    //签字版组件
    kw_signature_pad:resolve => require(['@/components/look/kw_signature_pad.vue'], resolve),
    OneFieldSet:resolve => require(['@/components/page/pageSet/OneFieldSet.vue'], resolve),
//     // 二维码组件
// import vueQr from 'vue-qr'
// import VueBarcode from "vue-barcode";
    vueQr:resolve => require(['vue-qr'], resolve),
    'barcode': resolve => require(['vue-barcode'], resolve),

    PageBasicSet:resolve => require(['@/components/page/pageSet/PageBasicSet.vue'], resolve),
    "ali-player":resolve => require(['@/components/live/VueAliplayer.vue'], resolve),
    'vue-ueditor-wrap':resolve => require(['@/components/vue-ueditor-wrap.vue'], resolve),
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    styleSetCodeZdy(json,rowData,dicIndex) {
      if(json) {
        var styleSetCode = json.styleSetCode;
        console.log("styleSetCode==============",styleSetCode);
        if(json.zdyJs) {
          styleSetCode += eval(json.zdyJs);
        }
        return styleSetCode;
      } else {
        return "";
      }
    },

//    吸顶
    handleScroll () {
      var that= this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if(scrollTop == 1){
        if(that.$refs.searchBar){
          that.tabTopHeight = that.$refs.searchBar.getBoundingClientRect().y
        }else{
          that.tabTopHeight = 310
        }
      }
      scrollTop > that.tabTopHeight ? that.searchBarFixed = true : that.searchBarFixed = false
    },





    /**
     * 初始化信息
     */
    initAtiached(){
      var that = this;
      var zdyPageUtils = pageUtils;
      var zdyUtils = utils;
      var pageInfo = that.pageInfo;
      if(pageInfo) {
        var pageId = pageInfo.pageId;
        var tableId = pageInfo.tableId;
        var pageType = pageInfo.pageType;
        var listTableId = pageInfo.listTableId;
        if (listTableId == undefined) {
          listTableId = 0;
        }
        var mainId = pageInfo.mainId;
        that.pageId = pageId;
        that.tableId = tableId;
        that.pageId = pageId;
        if(pageType) {
          that.pageType = pageType;
        }
        that.listTableId = listTableId;
        that.wxPayState = pageInfo.wxPayState;
        that.wxPayCode = pageInfo.wxPayCode;
        that.mainId = mainId;
      }
      if (that.initMainId > 0) {
        that.mainId = that.initMainId;
      }
      // 判断是否是预览功能
    if(that.isPreview == 1) {
      that.previewInitLoad();
    } else {
      if (that.initPageSetInfo == null) {
        //进行页面设置和数据加载
        pageUtils.loadAUPageSet(that, that.initPageDataInfo);
      } else {
        var pageSetInfo = that.initPageSetInfo;
        if (!pageSetInfo.styleSet) {
          pageSetInfo.styleSet = {};
        }
        if(!pageSetInfo.styleSet.setBlockingPC){
          pageSetInfo.styleSet.setBlockingPC = [{width:0}]
        }
        if(!pageSetInfo.listStyleSet) {
          pageSetInfo.listStyleSet = {};
        }
        that.pageSetInfo = pageSetInfo;
        var maxRowColJson = that.maxRowColJson;
        maxRowColJson.maxRow = pageSetInfo.maxRow;
        maxRowColJson.maxCol = pageSetInfo.maxCol;
        maxRowColJson.maxNum = (maxRowColJson.maxRow+1)*(maxRowColJson.maxCol+1);
        that.dataInfo = that.initPageSetInfo.dataInfo;
        pageUtils.initHideChildField(pageSetInfo.fieldSet,that);
        pageUtils.initAddOrUpdateDefaultValue(pageSetInfo.fieldSet,that);
        // console.log("=====================initAddOrUpdateDefaultValue-----子表格页面初始化---------",pageSetInfo);
        //调用切换页面的隐藏显示
        that.changeByshowHideJsList();
        if(that.initCustomVueJs) {
          try {
            eval(that.initCustomVueJs);
          } catch (error) {
            console.log("customVueJs执行报错了==========",error);
          }
        }
        that.hasLoad = true;
      }
    }
    },
    /**
     * 加载信息后的回调方法 进行数据逻辑处理 
     */
    initPageDataInfo(htData, that){
      var zdyPageUtils = pageUtils;
      var zdyUtils = utils;
      var pageSetInfo = htData.pageSet;
      var dataInfo = htData.initUpdateData ? htData.initUpdateData : htData.initGlAddData;
      //进行基础数据替换
      //循环字段信息 判断是否有
      var fieldSet = pageSetInfo.fieldSet;
      var dialogTableId = 0;
      if (!dataInfo) {
        dataInfo = {};
      }
      if(!pageSetInfo.tableId) {
        pageSetInfo.tableId = that.tableId;
      }
      if(!pageSetInfo.pageId) {
        pageSetInfo.pageId = that.pageId;
      }
      // if(pageSetInfo.pageType == 5) {
      that.pageType = pageSetInfo.pageType;
      // }
      if(!pageSetInfo.styleSet) {
        pageSetInfo.styleSet = {
          tabStyle:2
        };
      } else if(!pageSetInfo.styleSet.tabStyle) {
        pageSetInfo.styleSet.tabStyle = 2;
      }
      if(that.mainId != dataInfo["T_"+that.tableId+"_0"] && (pageSetInfo.pageType != 5 && pageSetInfo.pageType != 8)) {
        that.mainId = dataInfo["T_"+that.tableId+"_0"];
      } else if(pageSetInfo.pageType == 5 && dataInfo.MAINID > 0 && that.mainId != dataInfo.MAINID) {
        that.mainId = dataInfo.MAINID;
      }
      var maxRowColJson = that.maxRowColJson;
      maxRowColJson.maxRow = pageSetInfo.maxRow;
      maxRowColJson.maxCol = pageSetInfo.maxCol;
      maxRowColJson.maxNum = (maxRowColJson.maxRow+1)*(maxRowColJson.maxCol+1);
      pageUtils.initHideChildField(fieldSet,that);
      pageSetInfo.fieldSet = fieldSet;
      pageUtils.initToUpdateField(fieldSet, dataInfo, that, "", dialogTableId,pageSetInfo);
      pageUtils.initAddOrUpdateDefaultValue(fieldSet,that);
      //console.log("==============initAddOrUpdateDefaultValue 主=======fieldSet--------------",fieldSet);
      var pageId = that.pageId;
      var buttonCssStyle = pageUtils.initOperaButtonSet(pageSetInfo, pageId, that);
      // 循环一遍关联选项卡数据 进行
      var tabCurrent = -1;
     
      if(that.pageInfo.INIT_TAB_CURRENT*1 >= 0) {
        tabCurrent = that.pageInfo.INIT_TAB_CURRENT*1;
      }
      if(that.refreshPrevTabCurrent > 0) {
        tabCurrent = that.refreshPrevTabCurrent;
      }
      
      if (pageSetInfo.tabPageSet) {

        for (var i = 0; i < pageSetInfo.tabPageSet.length; i++) {
          var one = pageSetInfo.tabPageSet[i];
          // 如果是查看页面 进行数据处理
          if (one.type==11 || one.type==7 || one.type==5) {
            one.listTableId = one.mainTableId;
            if(that.listTableId > 0) {
              one.listTableId = that.listTableId;
            }
            one.pageType = one.type;
            one.mainId = that.mainId;
            one.ifLoaded = true;
          } else {
            if(that.listTableId > 0) {
               one.mainTableId = that.listTableId;
            }
          }
          // if(pageSetInfo.pageType == 5) {
          //   one.mainTableId = "";
          // }
          if (!one.styleSet) {
            one.styleSet = {};
            if(pageSetInfo.styleSet.tabStyle == 2) {
              one.styleSet.jumpWay = 4;
            }
          } else if(!one.styleSet.jumpWay) {
            if(pageSetInfo.styleSet.tabStyle == 2) {
              one.styleSet.jumpWay = 4;
            }
          }
          one.dataTotal = 0;
          if (one.styleSet && (one.styleSet.jumpWay == 4) && (dataInfo['BLOCK_SHOW_' + one.tabPageId] != 0)) {
            if (tabCurrent == -1) {
              tabCurrent = i;
            }
          }
        }
      }
      // 判断是否需要进行全局主键记录 
      if (pageSetInfo.styleSet && pageSetInfo.styleSet.ifGlobalId == 1) {
        if(localStorage.globalLookIdJson) {
          var globalLookIdJson = JSON.parse(localStorage.globalLookIdJson);
          if (!globalLookIdJson) {
            globalLookIdJson = {};
          }
          globalLookIdJson['page_' + pageId] = {
            pageId : pageId,
            mainId : that.mainId
          }
          localStorage.globalLookIdJson = JSON.stringify(globalLookIdJson);
        }
      }
      if(!pageSetInfo.listStyleSet) {
        pageSetInfo.listStyleSet = {};
      }
      if(!pageSetInfo.styleSet.setBlockingPC){
        pageSetInfo.styleSet.setBlockingPC = [{width:0}]
      }
      // 判断是否是弹出层打开页面如果是则进行保存取消按钮的显示
      if(!pageSetInfo.styleSet.updateButtonSet && (that.pageInfo.openWay == 2 || that.visitSource == 3)) {
        var updateButtonSet = [ 
          {
            buttonName:"保存",
            buttonType:20,
            cssStyle:1,
            ifShow:true,
            styleSet:{
              cssStyle:1
            }
          },{
            buttonName:"取消",
            buttonType:21,
            cssStyle:1,
            ifShow:true,
            styleSet:{
              cssStyle:1
            }
          }
        ]
        var loginInfo = JSON.parse(localStorage.loginInfo?localStorage.loginInfo:null);
        var USERID = 0;
        if(loginInfo) {
            USERID = loginInfo?loginInfo.USERID:-1
        }
        if(USERID == 0) {
          // updateButtonSet[updateButtonSet.length] = {
          //     buttonName:"接口查看",
          //     buttonType:99,
          //     cssStyle:1,
          //     ifShow:true,
          //     styleSet:{
          //         cssStyle:1
          //     }
          // }
        }
        if(pageSetInfo.pageType == 11) {
          updateButtonSet[0].ifShow = false;
        }
        pageSetInfo.styleSet.updateButtonSet = updateButtonSet;
      } else {
        pageUtils.initUpdateButtonSet(pageSetInfo, pageId, that);
      }
      if(typeof(pageSetInfo.ifShowSaveNewBtn) == "number" && pageSetInfo.ifShowSaveNewBtn == 0) {
        pageSetInfo.styleSet.updateButtonSet.push({
          buttonName:"保存并新建",
          buttonType:999,
          cssStyle:1,
          ifShow:true,
          styleSet:{
            cssStyle:1
          }
        })
      }
      
      if(utils.isNotNull(localStorage.loginInfo)) {
        var loginInfo = JSON.parse(localStorage.loginInfo);
        that.loginInfo = loginInfo;
      }
      //审批流程的处理显示
      var checkFlowList = htData.checkFlowList;
      if(pageSetInfo.ifAddCheckFlow == 1 && checkFlowList) {
        var checkFlowNowFloor = 0;
        var checkFlowFloorList = [];
        checkFlowList.forEach(element => {
          var CHECK_FLOOR = element.CHECK_FLOOR;
          var NEED_FLOOR = element.NEED_FLOOR;
          var CHECK_USERID = element.CHECK_USERID;
          var CHECK_USER = element.CHECK_USER;
          var CHECK_STATE = element.CHECK_STATE;
          var NODE_ID = element.NODE_ID;
          var floorJson = checkFlowFloorList[CHECK_FLOOR-1];
          if(!floorJson) {
            floorJson = {
              CHECK_FLOOR: CHECK_FLOOR,
              CHECK_USER: "",
              CHECK_USERID: "",
              NEED_FLOOR: NEED_FLOOR,
              NODE_ID: 148,
              PK_CFP_ID: 92,
              T_35_0: 148
            };
          }
          floorJson.CHECK_USER += (floorJson.CHECK_USER!=""?",":"") + CHECK_USER;
          floorJson.CHECK_USERID += (floorJson.CHECK_USERID!=""?",":"") + CHECK_USERID;
          if((that.loginInfo.USERID == CHECK_USERID || CHECK_STATE == 1 || CHECK_STATE == 2) && NEED_FLOOR == CHECK_FLOOR) {
            floorJson.NODE_ID = NODE_ID;
            floorJson.CHECK_STATE = CHECK_STATE;
            floorJson.REMARK = element.REMARK;
            if(that.loginInfo.USERID == CHECK_USERID) {
              floorJson.ifSave = true;
            }
          } else if(NEED_FLOOR > CHECK_FLOOR) {
            if(CHECK_STATE > 0) {
              floorJson.CHECK_STATE = CHECK_STATE;
              floorJson.CHECK_TIME = element.CHECK_TIME;
              floorJson.REMARK = element.REMARK;
            }
          }
          checkFlowFloorList[CHECK_FLOOR-1] = floorJson;
          checkFlowNowFloor = NEED_FLOOR-1;
        });
        that.checkFlowNowFloor = checkFlowNowFloor;
        that.checkFlowFloorList = checkFlowFloorList;
      }

      //判断是否有必填字段 并且是默认打开类型 如果是按照顺序进行页面打
      that.dataInfo = dataInfo;
      pageSetInfo.ifRefresh = true;
      that.pageSetInfo = pageSetInfo;
      that.buttonCssStyle = buttonCssStyle;
      that.tabCurrent = tabCurrent;
      that.WxValidate = new WxValidate({}, {});
      //调用切换页面的隐藏显示
      that.changeByshowHideJsList();
      that.hasLoad = true;
      

      // that.ZdyValidate = new ZdyValidate(that.data.tableId, that.data.pageId);
      // //执行页面初始化方法 
      // that.ZdyValidate.initPage(that);
      //自定义customVueJs
      if(pageSetInfo.customVueJs) {
        try {
          eval(pageSetInfo.customVueJs);
        } catch (error) {
          console.log("customVueJs执行报错了==========",error);
        }
      }

      that.$nextTick(function(){
        that.checkInitOpenDialog(0);
      });

      // 判断是否需要进行支付状态判断 
      if(that.pageSetInfo.styleSet) {
        var updateButtonSet = that.pageSetInfo.styleSet.updateButtonSet;
        if (updateButtonSet && updateButtonSet.length > 0) {
          var saveButtonSet = updateButtonSet[0];
          var nextOperaType = saveButtonSet.nextOperaType;
          // 支付按钮
          if(nextOperaType == 4) {
            if(that.dataInfo.ORDER_ID > 0) {
              that.checkPayState();
            }
            clearInterval(that.checkPaySuccessTimer);
            that.checkPaySuccessTimer = setInterval(that.checkPayState, 3000);
          }
        }
      }
      
    },
    /**
     * 检测是不是有需要进行自动打开的字段
     */
    checkInitOpenDialog(type){
      var that = this;
      var pageSetInfo = that.pageSetInfo;
      var fieldSet = pageSetInfo.fieldSet;
      var zdOpenNum = 0;
      for (var i = 0; i < fieldSet.length; i++) {
        if (fieldSet[i].styleSet && fieldSet[i].styleSet.showStyle == 5) {
          if (!fieldSet[i].ifHide) {
            if (!fieldSet[i].defaultCheckValue || fieldSet[i].defaultCheckValue=='') {
              // 调用组件的弹出层打开
                var fieldRefs = that.$refs["field_"+i][0];
                if(fieldRefs) {
                  fieldRefs.openChangeDialog();
                  return;
                }
            }
          }
          zdOpenNum ++;
        }
      }
      //是否自动保存 如果是 则进行保存
      if (type == 1 && zdOpenNum > 0) {
        pageUtils.saveAddOrUpdate(that, that.saveCallBack);
      }
    },
    /**
     * 保存方法
     */
    saveAddOrUpdate(buttonItem){
      var that = this;
    
      var buttonType = buttonItem.buttonType;
      if (buttonType == 20 || buttonType == 999) {
        var dataInfo = this.dataInfo;
        if (dataInfo.PREV_SAVE_FILE && dataInfo.PREV_SAVE_FILE.length > 0 && !this.prevSaveChecked) {
          this.$message({
            message: '请同意协议!',
            offset:50
          });
          return;
        }
      }
      if (buttonType == 20 || buttonType == 999) {
        var ifNextSave = true;
        if(that.pageSetInfo.ifAddCheckFlow == 1) {
          //that.saveCallBack  现在审批流程保存完毕后又调用
          ifNextSave = pageUtils.saveCheckFlowData(that, function(){
            pageUtils.saveAddOrUpdate(that, that.saveCallBack);
          });
        }
        //判断 关联选项卡中 是否有添加或修改页面 如果有 则进行连带校验 校验全部通过后 再进行保存
        var ifJxSave = that.checkTabPageSet();
        if(ifJxSave) {
          if(buttonType == 999) {
            pageUtils.saveAddOrUpdate(that, that.saveAfterAddCallBack);
          } else {
            if(ifNextSave) {
              // 保存
              pageUtils.saveAddOrUpdate(that, that.saveCallBack);
            }
          }
        }
      } else if (buttonType == 21) {
        // 取消
        that.$emit("goBack");
      } else if(buttonType == 99) {
        //接口文档查看
        var dialogInfo = that.dialogInfo;
        var url = "model_getInterFaceParam.do"
        dialogInfo.type = 999;
        // 获取按钮的参数信息 进行url绑定
        dialogInfo.url = that.GLOBAL.baseURL + url + "?pageId="+that.pageId;
        dialogInfo.sourceOpenThat = that;
        dialogInfo.pageInfo = {
            menuName:"接口查看"
        }
        dialogInfo.ifLoad = true;
      }
    },
    /**
     * 页面元素的点击事件
     */
    elementClick:function(fieldSet) {
      var styleSet = fieldSet.styleSet;
      if (styleSet) {
        if (styleSet.clickPageId > 0 && styleSet.clickTableId > 0) {
          // 跳转列表页面
          if (styleSet.clickType == 3) {
            var toListJson = {
              pageId: styleSet.clickPageId,
              tableId: styleSet.clickTableId
            }
            pageUtils.toNewListPage(this,toListJson);
          } else if (styleSet.clickType == 4) {
            //修改功能
            var jumpJson = {
              pageId: styleSet.clickPageId,
              tableId: styleSet.clickTableId,
              mainId: this.mainId,
              callBackType: 1,
              listTableId: styleSet.clickTableId
            };
            pageUtils.toNewLookPage(this,jumpJson);
          }  else if (styleSet.clickType == 5) {
            var aux = document.createElement("input"); 
            aux.setAttribute("value", fieldSet.defaultValStr); 
            document.body.appendChild(aux); 
            aux.select();
            document.execCommand("copy"); 
            document.body.removeChild(aux);
            that.$message({
              message: '复制成功!',
              type: 'success'
            });
          }

        }
      }
    },
    //保存前 校验关联选项卡中如果有 修改或者关联添加页面的必填性
    checkTabPageSet(){
      var that = this;
      var ifJxSave = true;
      var tabPageSet = that.pageSetInfo.tabPageSet;
      if (tabPageSet) {
        for (var i = 0; i < tabPageSet.length; i++) {
          var one = tabPageSet[i];
          //判断类型 是添加或修改
          if(one.type == 7 || one.type == 5) {
            var refKey = 'tabPageSet_kw_look_'+i;
            if(that.$refs[refKey]){
              var oneKwLook = typeof(that.$refs[refKey].length)=='number'?that.$refs[refKey][0]:that.$refs[refKey];
              var toHtData = pageUtils.getToHtData(oneKwLook, 0);
              //console.log("toHtData==========保存前获取1===========",JSON.stringify(toHtData),toHtData.errorMessage);
              if (toHtData.errorMessage && toHtData.errorMessage != "") {
                  that.$message({
                      message: one.tabName + '校验不通过:'+toHtData.errorMessage,
                      type: 'error',
                      offset: 50
                  });
                  ifJxSave = false;
              }
            }
          }
        }
      }
      return ifJxSave;
    },
    //保存 关联选项卡中如果有 修改或者关联添加页面进行保存
    saveTabPageSet() {
      var that = this;
      var tabPageSet = that.pageSetInfo.tabPageSet;
      
      if (tabPageSet) {
        for (var i = 0; i < tabPageSet.length; i++) {
          var one = tabPageSet[i];
          console.log("one===============================",one);
          //判断类型 是添加或修改
          if(one.type == 7 || one.type == 5) {
            var refKey = 'tabPageSet_kw_look_'+i;
            if(that.$refs[refKey]){
              console.log("that.$refs[refKey]===============================",refKey,that.$refs,that.$refs[refKey]);
              var oneKwLook = typeof(that.$refs[refKey].length)=='number'?that.$refs[refKey][0]:that.$refs[refKey];
              pageUtils.saveAddOrUpdateToHt(oneKwLook, null);
            }
          }
        }
      }
    },
    /**
     * 保存成功后 执行的方法
     */
    saveCallBack(saveResult, that){
      
      that.saveTabPageSet();
      console.log("saveTabPageSet===============后==================");
      //保存后 调用关联选项卡列表的数据刷新
      var updateButtonSet = that.pageSetInfo.styleSet.updateButtonSet;
      var nextOperaType = -1;
      if (updateButtonSet) {
        
        var saveButtonSet = updateButtonSet[0];
        nextOperaType = saveButtonSet.nextOperaType;
        var tableId = saveButtonSet.clickTableId;
        var pageId = saveButtonSet.clickPageId;
        var mainId = that.mainId;

        // 如果校验通过后 则读取设置 判断是否进行头条系的访问记录
        var headlinesReport = saveButtonSet.headlinesReport;
        if(headlinesReport == 1) {
          // meteor.track('form', {convert_id: 1667204997381134 });
          // if(meteor) {
          //   meteor.track('shopping', {convert_id: 1667215247721484 });
          // }
		      if(that.dataInfo && that.dataInfo.TOUTIAO_JS) {
            eval(that.dataInfo.TOUTIAO_JS);
          }
        }

        var delayMillisecond = 3000;
        if(saveButtonSet && saveButtonSet.delayMillisecond > 0) {
            delayMillisecond = saveButtonSet.delayMillisecond;
        }

        // 支付类型是否当前页面对象支付
        var payType = 1;
        console.log("saveResult===================",saveResult,typeof saveResult);
        // 跳转详情页面
        if (typeof saveResult == "object") {
          var resJson = saveResult;
          mainId = resJson.ID;
          if (resJson.tableId > 0) {
            tableId = resJson.tableId;
          }
          if (resJson.pageId > 0) {
            pageId = resJson.pageId;
          }
          if(resJson.PAY_TYPE == 2) {
            payType = 2;
          }
          if(resJson.nextOperaType) {
            nextOperaType = resJson.nextOperaType;
          }
          if (resJson.CONTENT && resJson.CONTENT != '') {
            var messageType = "success";
            if(!(mainId > 0)) {
              messageType = "error";
            }
            that.$message({
              showClose: true,
              message: resJson.CONTENT,
              offset:50,
              type:messageType,
              duration:delayMillisecond
            });
          }
        } else {
          mainId = saveResult;
          if(!(mainId > 0)) {
            var errMessage = "保存失败";
            if(typeof(saveResult) == "string") {
              errMessage+=":"+saveResult;
            }
            that.$message({
              showClose: true,
              message: saveResult,
              offset:50,
              type: 'error',
              duration:delayMillisecond
            });
          } else {
            that.$message({
              showClose: true,
              message: "保存成功",
              offset:50,
              type: 'success',
              duration:delayMillisecond
            });
          }
        }
        var dataInfo = that.dataInfo;
        if (nextOperaType == 4) {
          console.log("payType=====================",payType,saveResult);
          if(payType == 2) {
            var resJson = saveResult;
            dataInfo = resJson;
            mainId = resJson.ID;
            that.ORDER_ID = mainId;
          } 
          // 打开支付页面
          if (dataInfo.FINAL_MONEY > 0) {
            var orderJson = {
              ORDER_ID: mainId,
              ORDER_MONEY: dataInfo.FINAL_MONEY,
              dataInfo: dataInfo,
              PAY_WAY:dataInfo.PAY_WAY,
              PAY_PLAT:dataInfo.PAY_PLAT
            }
            pageUtils.toApply(orderJson, that);
          } else {
            that.orderPayNext();
          }
        } else if (nextOperaType == 2) {
          // 跳转详情页
          var jumpJson = {
            pageId: pageId,
            tableId: tableId,
            mainId: mainId,
            callBackType: 1,
            listTableId: tableId
          };
          if(saveButtonSet.nextOperaCloseNow == 1) {
            jumpJson.jumpWay = 1;
          }
          if (saveButtonSet.delayMillisecond > 0) {
            setTimeout(function () {
              pageUtils.toNewLookPage(that,jumpJson);
            }, saveButtonSet.delayMillisecond);
          } else {
            pageUtils.toNewLookPage(that,jumpJson);
          }
        } else if (nextOperaType == 3) {
          // 跳转列表页面
          var toListJson = {
            pageId: pageId,
            tableId: tableId,
            initCheckId: 0,
            callBackType: 0,
            dataMaxNum: 1
          }
          if(saveButtonSet.nextOperaCloseNow == 1) {
            toListJson.jumpWay = 1;
          }
          if (saveButtonSet.delayMillisecond > 0) {
            setTimeout(function () {
              pageUtils.toNewListPage(that,toListJson);
            }, saveButtonSet.delayMillisecond);
          } else {
            pageUtils.toNewListPage(that,toListJson);
          }
        } else if (nextOperaType == 1) {
          var kw_look = pageUtils.getPageKwLook(that);
          kw_look.hasLoad = false;
          kw_look.$nextTick(function(){
            // 默认本页刷新
            kw_look.initAtiached();
          });
        } else if(nextOperaType == 12) {
          //刷新最外层查看页面的子选项卡列表
          var kw_look = null;
          that.getParentKwLook(val => {
              kw_look = val
          });
          if(kw_look) {
              var pageSetInfo = kw_look.pageSetInfo;
              if(pageSetInfo.tabPageSet){
                for (var i = 0; i < pageSetInfo.tabPageSet.length; i++) {
                  if(kw_look.$refs["kw_list_" + i] && kw_look.$refs["kw_list_" + i].length>0) {
                    kw_look.$refs["kw_list_" + i][0].initLoadDataInfo();
                  }
                }
              }
          }
          if(mainId > 0) {
            that.dataInfo.mainId = mainId;
            that.$emit("goBack",1,that.dataInfo);
          }
        } else if(nextOperaType == 14) {
          if(pageId > 0 && tableId > 0) {
            // 跳转详情页
            var jumpJson = {
              pageId: pageId,
              tableId: tableId,
              pageType:5,
              mainId: mainId,
              callBackType: 1,
              listTableId: that.pageSetInfo.tableId
            };
            // var kw_look = that.getOneParentKwLook();
            //console.log("kw_look==========1111111===========",that.$parent.$parent);
            if (saveButtonSet.delayMillisecond > 0) {
              setTimeout(function () {
                pageUtils.toNewLookPage(that.$parent.$parent,jumpJson);
              }, saveButtonSet.delayMillisecond);
            } else {
              pageUtils.toNewLookPage(that.$parent.$parent,jumpJson);
            }
          } else {
            try {
              _flutterZdyRefreshPage.postMessage("prev");
            } catch (error) {
            }
            that.dataInfo.mainId = mainId;
            that.$emit("goBack",1,that.dataInfo);
          }
        } else {
          // 默认保存的后续操作为 关闭本页 返回上一页 并进行上一页的重新加载刷新
          // var kw_look = pageUtils.getPageKwLook(that);
          // kw_look.$emit("goBack");
          //判断是否是flutter环境，如果是则调用前一个页面的刷新方法
          if(mainId > 0) {
            try {
              _flutterZdyRefreshPage.postMessage("prev");
            } catch (error) {
            }
            that.dataInfo.mainId = mainId;
            that.$emit("goBack",1,that.dataInfo);
          }
        }
        
      }
      // 进行选项卡列表数据刷新
      if(nextOperaType != 1) {
        var pageSetInfo = that.pageSetInfo;
        if(pageSetInfo.tabPageSet){
          for (var i = 0; i < pageSetInfo.tabPageSet.length; i++) {
            if(that.$refs["kw_list_" + i] && that.$refs["kw_list_" + i].length>0) {
              that.$refs["kw_list_" + i][0].initLoadDataInfo();
            }
          }
        }
      }
    },
    /**
     * 保存并新建
     */
    saveAfterAddCallBack(saveResult, that) {
      // 保存并新建保存后 判断是否清空页面显示值
      var updateButtonSet = that.pageSetInfo.styleSet.updateButtonSet;
      if (updateButtonSet) {
        var saveButtonSet = updateButtonSet[0];
        var delayMillisecond = 3000;
        if(saveButtonSet && saveButtonSet.delayMillisecond > 0) {
            delayMillisecond = saveButtonSet.delayMillisecond;
        }
        var message = "";
        var resultId = 0;
        if (typeof saveResult == "object") {
          var resJson = saveResult;
          message = resJson.CONTENT;
          resultId = resJson.ID
        } else {
          resultId = saveResult;
          message = saveResult;
        }
        if(!(resultId > 0)) {
          that.$message({
            showClose: true,
            message: message,
            offset:50,
            type: 'error',
            duration:delayMillisecond
          });
        } else {
          that.$message({
            showClose: true,
            message: "保存成功,可以继续新建数据",
            offset:50,
            type: 'success',
            duration:delayMillisecond
          });
          //判断是否清空页面值 ifCleanPage
          if(typeof(that.pageSetInfo.ifCleanPage) == "number" && that.pageSetInfo.ifCleanPage == 0) {
            that.pageSetInfo.fieldSet.forEach(fieldOne=>{
              pageUtils.clearFieldCheckValue(fieldOne,that);
            })
            that.$forceUpdate();
          }
        }
      }
    },
    /**
     * 支付成功之后的跳转页面
     */
    orderPayNext() {
      var that = this;
      // 跳转到已支付列表
      var saveButtonSet = this.pageSetInfo.styleSet.updateButtonSet[0];
      if (saveButtonSet) {
        var clickTableId = saveButtonSet.clickTableId;
        var clickPageId = saveButtonSet.clickPageId;
        var clickPageType = saveButtonSet.clickPageType;
        if(clickPageType == 11 || clickPageType == 7) {
          var mainId = this.mainId;
          if(that.ORDER_ID > 0) {
            mainId = that.ORDER_ID;
          }
          var jumpJson = {
            pageId: clickPageId,
            tableId: clickTableId,
            mainId: mainId
          };
          
          pageUtils.toNewLookPage(this,jumpJson);
        } else {
          console.log("that.$router.history==================",that.$router.history);
          //跳转到具体的列表页面   需要把搜索条件传递过去
          var toListJson = {
            pageId: clickPageId,
            tableId: clickTableId,
            initCheckId: 0,
            callBackType: 0,
            dataMaxNum: 1
          }
          // 传递列表页面的搜索条件的默认选中
          pageUtils.toNewListPage(this,toListJson);
        }
      }
    },
    /**
     * 开关组件的触发事件
     */
    bindElementChangeSwitch:function(e){
      var checkState = e.detail;
      var newE = e;
      if (checkState) {
        newE.detail={
          value: 1
        }
      } else {
        newE.detail = {
          value: 2
        }
      }
      this.bindElementChange(newE);
    },
    /**
     * 下拉组件切换时的方法
     */
    bindElementChange: function (nowField, filedindex) {
      var that = this;
      var fieldType = nowField.fieldType;
      if (fieldType == 1) {
        // 数字类型搜索条件
        pageUtils.bindInputBlur(that,nowField);
      } else if (fieldType == 2) {
        // 字符类型搜索条件
        pageUtils.bindInputBlur(that,nowField);
      } else if (fieldType == 3) {
        //console.log("nowField.defaultValStr=========1111========",nowField.defaultValStr);
        // 日期类型搜索条件
        if(typeof(nowField.defaultValStr) == 'object') {
          // nowField.defaultValStr = pageUtils.dateFormat(nowField.defaultValStr, nowField.dateType)+'';
          that.$set(nowField,'defaultValStr',pageUtils.dateFormat(nowField.defaultValStr, nowField.dateType))
          //console.log("nowField.defaultValStr========2222=========",nowField,nowField.defaultValStr);
        }
        pageUtils.bindDateChange(that,nowField);

      } else if (fieldType == 4) {
        // 下拉框切换
        if(nowField.fieldRole==16) {
          pageUtils.bindPickerChangeValue(that,nowField);
        } else {
          pageUtils.bindPickerChange(that,nowField);
        }
      }  else if (fieldType == 5) {
        // if (nowField.chooseType == 2) {
        // pageUtils.bindDialogChange(nowField);
          // pageUtils.confirmDialogCallBack(that, nowField, nowField.filedindex);
        // }
        // pageUtils.confirmDialogCallBack(that, nowField, filedindex);
      }
      // if(nowField.ifToHtValid == 1) {
      //   //是否要后台校验
      //   that.toHtValid(nowField);
      // }
      that.changeByshowHideJsList();
      that.$forceUpdate();
    },
    
    /**
     * 查看页面的按钮点击事件
     */
    dataButtonClick: function (buttonOne) {
      var that = this;
      var dataInfo = that.dataInfo;
      pageUtils.dataButtonClick(that,buttonOne,dataInfo);
    },
    /**
     * 关联选项卡 点击更多时 进行页面跳转
     */
    tabPageToList(pageInfo){
      var that = this;
      var styleSet = pageInfo.styleSet;
      if(styleSet.clickPageType && styleSet.clickPageType.startsWith("mailHome:")) {
        that.pageInfo.initActiveName = styleSet.clickPageType.replace("mailHome:","");
        //修改功能
        pageUtils.toMailHome(that);
      } else {
        //跳转到具体的列表页面   需要把搜索条件传递过去
        var toListJson = {
          pageId: styleSet.clickPageId,
          tableId: styleSet.clickTableId,
          initCheckId: 0,
          callBackType: 0,
          dataMaxNum: 1,
          sourceListMainId:this.mainId
        }
        pageUtils.toNewListPage(this,toListJson);
      }
    },
    /**
    * 后台检测是否支付成功
    */
   checkPayState: function () {
        var that = this;
        var tableId = 0;//18070;
        var pageId = 0;//12198;
        if(utils.isNotNull(localStorage.ecshopSysSet)) {
          var ecshopSysSet = JSON.parse(localStorage.ecshopSysSet);
          if(ecshopSysSet) {
            tableId = ecshopSysSet.ORDER_TABLE;
            pageId = ecshopSysSet.ORDER_DETAIL_PAGE;
          } 
        } else {
          var domainName = "default";
          var defaultPayStateInfo = that.GLOBAL.defaultPayStateInfo;
          if(localStorage.domain_name && localStorage.domain_name != "" && defaultPayStateInfo[localStorage.domain_name]) {
            domainName = localStorage.domain_name;
          }
          tableId = defaultPayStateInfo[domainName].tableId;
          pageId = defaultPayStateInfo[domainName].pageId;
        }
        var orderId = that.mainId;
        if(that.tableId != tableId) {
          orderId = that.ORDER_ID;
          if(!(orderId>0)) {
            orderId = that.dataInfo.ORDER_ID;
          }
        }
        if(pageId > 0 && tableId > 0) {
          if(orderId > 0) {
              var toHtData = {};
              //tableId 表id
              toHtData.tableId = tableId;
              toHtData.mainTableId = tableId;
              //pageId 页面id
              toHtData.pageId = pageId;
              toHtData.mainId = orderId;
              toHtData.pageType = 7;
              var url = 'wxXcxSet_getToUpdateData.do';
              this.$axios.post(url,toHtData).then(res => {

                  if(res.data) {
                    var checkOrderInfo = res.data.rows[0];
                    //已支付
                    if(checkOrderInfo.IF_PAY == 1) {
                        clearInterval(that.checkPaySuccessTimer);
                        that.$message({
                          type: 'info',
                          message: '支付成功!返回我的订单中!'
                        });  
                        that.orderPayNext();
                    }
                  }
              }).catch(error => {
                clearInterval(that.checkPaySuccessTimer);
              });
          }
        } else{
          clearInterval(that.checkPaySuccessTimer);
          that.$message({
              type: 'info',
              message: '超时!请刷新!重新从主页面进入!'
          });  
        }
    },
    /**
     * 其他页面调用本页面的方法
     */
    zdyParentEvent: function (detail) {
      var that = this;
      var clickType = detail.clickType;
      var fieldId = detail.fieldId;
      var pageSetInfo = this.pageSetInfo;
      if (clickType == 1) {
        // 打开页面的某个字段的弹出层
        var fieldSet = pageSetInfo.fieldSet;
        var name_indexMap = pageSetInfo.name_indexMap;
        var fieldIndex = name_indexMap["name_" + fieldId];
        // 把fieldIndex之后的默认打开的字段 选中内容清空
        for (var i = fieldIndex+1; i < fieldSet.length; i++) {
          if (fieldSet[i].styleSet && fieldSet[i].styleSet.showStyle == 5) {
            // if (!fieldSet[i].ifHide) {
              fieldSet[i].defaultCheckValue = "";
              fieldSet[i].defaultCheckCnName = "";
              fieldSet[i].defaultCheckDataList = [];
              fieldSet[i].defaultCheckValueIndex = "";
              fieldSet[i].defaultCheckIndexArr = [];
            }
          // }
        }

        var fieldRefs = that.$refs["field_"+fieldIndex][0];
        fieldRefs.openChangeDialog();
      } else if (clickType == 2) {
        // 进行查看页面选项卡数据的修改
        //console.log("detail==============================",detail);
        var total = detail.total;
        var parentTabIndex = detail.parentTabIndex;
        if((parentTabIndex != null && parentTabIndex != undefined) && pageSetInfo.tabPageSet.length > parentTabIndex) {
          var tabPageSetOne = pageSetInfo.tabPageSet[parentTabIndex];
          tabPageSetOne.dataTotal = total;
          tabPageSetOne.pageDataInfo = detail.pageDataInfo;
          var ifHideCount = pageSetInfo.styleSet?pageSetInfo.styleSet.ifHideCount:0;
          // this.pageSetInfo = pageSetInfo;
          var dataInfo = this.dataInfo;
          var tabCurrent = this.tabCurrent;
          if (ifHideCount == 1 && total == 0 && !tabPageSetOne.hasLoad) {
            dataInfo['BLOCK_SHOW_' + tabPageSetOne.tabPageId] = 0;
          }
          tabPageSetOne.hasLoad = true;
          // this.setData({
          //   pageSetInfo: pageSetInfo,
          //   dataInfo: dataInfo
          // })
          if (ifHideCount == 1) {
            var newTabCurrent = -1;
            for (var i = 0; i < pageSetInfo.tabPageSet.length; i++) {
              var one = pageSetInfo.tabPageSet[i];
              if (one.styleSet && (one.styleSet.jumpWay == 4) && (dataInfo['BLOCK_SHOW_' + one.tabPageId] != 0)) {
                if (newTabCurrent == -1) {
                  newTabCurrent = i;
                }
                if (tabCurrent == i) {
                  newTabCurrent = tabCurrent;
                }
              }
            }
            that.tabCurrent = newTabCurrent;
          }
        }
        pageSetInfo.ifRefresh = !pageSetInfo.ifRefresh;
        console.log("pageSetInfo.ifRefresh=================",pageSetInfo.ifRefresh);
      }
    },
    /**
     * 发送验证码
     */
    sendMsgYzm:function(fieldOne){
      var that = this;
      pageUtils.sendMsgYzm(that,fieldOne);
    },
    checkPhoneYzm:function(fieldOne){
      var that = this;
      pageUtils.checkPhoneYzm(that,fieldOne,null,null);
    },
    /**
      * 定时器进行秒倒计时
      */
    getAuthCode() {
        if (this.authTimeTimer) {
            clearTimeout(this.authTimeTimer);
        }
        this.authTimeTimer = setTimeout(() => {
            this.auth_time -= 1;
            if (this.auth_time < 0) {
                this.yzmFlag = false;
                this.yzmText = "发送验证码";
                clearTimeout(this.authTimeTimer);
            } else {
                this.yzmText = this.auth_time + "后重新发送";
                this.getAuthCode();
            }
        }, 1000);
    },
    /**
     * 右上角按钮组 点击事件
     */
    actionSheetArrClick: function (command) {
      var that = this;
      var actionSheetArr = that.actionSheetArr;
      var dataInfo = that.dataInfo;
      var buttonOne = that.pageSetInfo.operaButtonSet[command];
      pageUtils.dataButtonClick(that,buttonOne,dataInfo);
    },
    /**
     * 弹出层打开之后的回调事件
     */
    dialogFieldCallBack:function(detail){
      var that = this;
      
      // 调用自定义回调事件 
      var fieldId = detail.fieldId;
      //console.log("fieldId=========================",fieldId,that);
      // 调用自定义回调事件 
      if(typeof(this["zdyValueChange_"+fieldId]) == "function") {
        console.log("fieldId=========2222222================",fieldId);
          this["zdyValueChange_"+fieldId](that,utils,pageUtils);
      }
      that.$forceUpdate();
      this.checkInitOpenDialog(1);

      //判断处理逻辑 如果是默认选中则需要进行自动加载的切换  如果不是默认选中考虑清除选中(暂时不加)
      var nowField = detail;
      var kw_look = that;
      var pageSetInfo = kw_look.pageSetInfo;
      var prevFieldSet = pageSetInfo.fieldSet;
      var nowFieldId = nowField.fieldId;
      prevFieldSet.forEach((fieldOne, xhIndex) => {
        var xhFieldType = fieldOne.fieldType;
        var xhNeedFilter = fieldOne.needFilter;
        if(xhFieldType == 5 && xhNeedFilter) {
          var xhAddStyle = fieldOne.addStyle;
          if(xhNeedFilter.endsWith(":"+nowFieldId) || xhNeedFilter.indexOf(":"+nowFieldId+",")>0) {
            //判断处理逻辑 如果是默认选中则需要进行自动加载的切换  如果不是默认选中考虑清除选中(暂时不加)
            if(xhAddStyle == 2) {
              var fieldRef = typeof(kw_look.$refs["field_"+xhIndex].length)=='number'?kw_look.$refs["field_"+xhIndex][0]:kw_look.$refs["field_"+xhIndex];
              fieldRef.initAttach();
            } else{
              //清空关联弹出层字段的当前选中值
              pageUtils.clearFieldCheckValue(fieldOne,that);
              that.$forceUpdate();
            }
          }
        }
      });
    },
    /**
     * 下拉框是否动态进行后台数据加载
     */
    remoteMethod:function(fieldOne,filedIndex){
      var that = this;
      var needFilter = fieldOne.needFilter;
      if(needFilter != null && needFilter != "") {
        that.filedIndex = filedIndex;
        pageUtils.autoGetDialogData(fieldOne,that);
        that.filedIndex = null;
      }
    },
    /**
     * 下拉框弹出层数据加载后的处理逻辑
     */
    dialogClickCallBack:function(detail){
      var dicList = [];
      detail.checkDataInfo.forEach(element => {
        var dicOne = element;
        dicOne.DIC_ID = element["T_"+detail.fieldOne.dialogTableId+"_0"]+"";
        dicOne.DIC_NAME = element.AFM_1;
        dicList.push(dicOne);
      });
      detail.fieldOne.dicList = dicList;
    },
    /**
     * 去打开文件查看信息
     */
    toOpenFile:function (){
      var that = this;
      var dataInfo = this.dataInfo;
      //直接下载按钮
      var fileId = dataInfo.PREV_SAVE_FILE;
      if (fileId == null || fileId.length == 0) {
        this.$message({
          message: '无相关文件',
          type: 'error'
        });
        return;
      }
      utils.openFile(that,fileId);
    },
    /**
     * 返回前一页
     */
    goBack(){
      this.$emit("goBack");
    },
    /**
     * 关联显示页面 展现形式为选项卡时  进行滚动条定位 或者选项卡切换
     */
    pageTabchange({ detail }){
      // 进行滚动条定位 或者 选项卡切换
      console.log("detail===============",detail);
    },
	  
    /**
     * 文件开始上传时调用
     */
    progressFile:function(file, fileList, fieldone){
      var that = this;
      console.log("开始上传中----");
      fieldone.loadingFile = true;
      that.$forceUpdate();
    },
    /**
     * 文件上传成功时的处理函数
     */
    successFile:function(response, file, fileList, fieldone){
     
      var that = this;
      var arr = response.split(":");
      var downAddress = arr[0];
      var fileId = arr[1];
      file.fileId = fileId;
      file.downAddress = downAddress;
      var toHtId = "";
      fileList.forEach(element => {
        if(element.status == "success") {
          if(toHtId!="") {
            toHtId+=","
          }
          toHtId+=element.fileId;
        }
        var name = element.name;
        element.fileType = pageUtils.getFileTypeByName(name);
      });
      fieldone.defaultValStr = toHtId;
      fieldone.defaultFileNum = toHtId ? toHtId.split(",").length : 0;
      fieldone.fileList = fileList;
      fieldone.showFileListFlag = 2;
      fieldone.loadingFile = false;
      console.log("上传完毕----",fieldone);
      that.$forceUpdate();
    },
    /**
     * 点击上传按钮时触发
     */
    clickElUpload(index,item) {
      // 判断是否是flutter内打开项目 如果是则修改附件上传按钮
      var fileType = item.fileType
      try {
        _flutterPickFileUpload.postMessage(fileType + "," + index);
      } catch (error) {
        console.log("不是app环境中打开");
      }
    },
    /**
     * flutter文件上传成功的回调处理
     */
    flutterSuccessFile:function(newFileList,fieldIndex){
      var that = this;
      console.log("newFileList=================",newFileList);
      var newFileListArr = JSON.parse(newFileList);
      console.log("fieldIndex=================",fieldIndex);
      var that = this;
      var fieldone = that.pageSetInfo.fieldSet[fieldIndex];
      var fileList = fieldone.fileList;
      if(!fileList) {
        fileList = [];
      }
      var toHtId = fieldone.defaultValStr;
      if(newFileListArr != null) {
        newFileListArr.forEach(addFieldOne => {
          var file = {};
          var arr = addFieldOne.split(":");
          var downAddress = arr[0];
          var fileId = arr[1];
          var name = arr[2];
          file.fileId = fileId;
          file.downAddress = downAddress;
          file.fileName = name;
          file.name = name;
          file.fileType = pageUtils.getFileTypeByName(name);
          if(toHtId!="") {
            toHtId+=","
          }
          toHtId+=file.fileId;
          fileList.push(file);
        });
        fieldone.defaultValStr = toHtId;
        fieldone.defaultFileNum = toHtId ? toHtId.split(",").length : 0;
        fieldone.fileList = fileList;
      }
      console.log("fieldone=================",JSON.stringify(fieldone));
      that.$forceUpdate();
    },
    /**
     * 点击时下载附件
     */
    downLoadFile:function(file,fieldone) {
      // 可以增加下载权限的判断
      var url = this.GLOBAL.getFileServeUrl()+escape(file.downAddress);
      var ifFlutter = false;
      try {
          if(_flutterDownloadFile) {
              _flutterDownloadFile.postMessage(url + "_kw_" + file.name);
              ifFlutter = true;
          }
      } catch (error) {
      }
      if(!ifFlutter) {
        const link = document.createElement('a')
        link.setAttribute("download", file.name) //下载的文件名
        link.target = "_blank";
        link.href = url;   //文件url
        link.click()
        // pageUtils.downLoadFile(url,{},file.name,this);
      }
    },
    beforeUploadLoadFile:function(file,item) {
      console.log("file=======================" , file);
      // 判断文件的要求格式和文件大小是否符合要求
      var fileTypeFlag = true;
      if(item.fileType) {
        var nowFileType = file.name.substring(file.name.lastIndexOf(".")+1);
        if(item.fileType.indexOf("."+nowFileType) >= 0) {
          fileTypeFlag = true;
        } else {
          fileTypeFlag = false;
        }
      }
      var fileSizeFlag = true;
      if(item.fileSize > 0) {
        if(file.size / 1024 <= item.fileSize) {
          fileSizeFlag = true;
        } else {
          fileSizeFlag = false;
        }
      }

      if (!fileTypeFlag) {
        this.$message.error('上传文件要求格式' + item.fileType + '!');
      }
      if (!fileSizeFlag) {
        this.$message.error('上传文件大小不能超过 ' + (item.fileSize/1024).toFixed(2) + 'MB!');
      }
      return fileTypeFlag&&fileSizeFlag;
    },
    /**
     * 打开文件预览组件
     */
    toPreviewFile:function(file,fieldone) {
      var that = this;
      pageUtils.toPreviewFile(that,file,fieldone);
      // window.open(url);
    },
    hiddenPreviewDialog:function(){
      this.filePreviewInfo.ifShow = false;
    },
    /**
     * 上传失败时执行
     */
    errorFile:function(err, file, fileList,fieldone){
      fieldone.loadingFile = false;
    },
    /**
     * 文件删除时的处理函数
     */
    removeFile:function(scope, fileList,fieldone){
      var that = this;
      fileList.splice(scope.$index,1); 
      var toHtId = "";
      fileList.forEach(element => {
        if(element.status == "success") {
          if(toHtId!="") {
            toHtId+=","
          }
          toHtId+=element.fileId;
        }
        var name = element.name;
        element.fileType = pageUtils.getFileTypeByName(name);
      });
      fieldone.defaultValStr = toHtId;
      fieldone.defaultFileNum = toHtId ? toHtId.split(",").length : 0;
      fieldone.fileList = fileList;
    },
    /**
     * 文件上传个数超出时进行提醒
     */
    exceedFile:function(files, fileList, fieldone) {
      this.$message.warning(`当前限制选择 ${fieldone.fileNum} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    /**
     * 进行子表格数据切换
     */
    changeScheduleData:function(fieldSetIndexArr, callBackIndex){
      pageUtils.confirmDialogCallBack(this,fieldSetIndexArr, callBackIndex);
    },
    /**
     * 点击加号增加一条数据
     */
    addChildJson:function(nowField,index) {
      var that = this;
      var pageSetInfo = this.pageSetInfo;
      var prevDateIndex =that.nowDataIndex;
      var dialogIdName = nowField.dialogIdName;
      var updateIdName = nowField.updateIdName;
      var childFieldSetBase = nowField.childFieldSet;
      var tmpString1 = JSON.stringify(childFieldSetBase);
      var childFieldSet = JSON.parse(tmpString1);
      if(!nowField.childPageJsonArr) {
        nowField.childPageJsonArr = [];
      }
      var childMaxCol = 0;
      for (var k = 0; k < childFieldSet.length; k++) {
        childFieldSet[k].prevFieldIndex = (nowField.prevFieldIndex != undefined ? nowField.prevFieldIndex : "") + ":" + (nowField.nowFieldIndex != undefined ? nowField.nowFieldIndex : "") + "-" + prevDateIndex;
        if(!childFieldSet[k].ifHide) {
            childMaxCol++;
        }
        pageUtils.loadFieldRulesByField(childFieldSet[k]);
      }
      var oneChildJson = {
        "fieldSet": childFieldSet,
        "defaultIdStr": "",
        "nowDataIndex": nowField.childPageJsonArr.length,
        "prevDateIndex": prevDateIndex,
        "dialogIdName": dialogIdName,
        "updateIdName": updateIdName,
        "updateDataId": 0,
        "dataInfo": {},
        "maxRow":0,
        "maxCol":childMaxCol>1?childMaxCol-1:childMaxCol,
        "showHideJsList":pageSetInfo.showHideJsList,
        "name_indexMap":pageSetInfo.name_indexMap
      }
      nowField.childPageJsonArr.push(oneChildJson);
      nowField.childMaxCol = childMaxCol>1?childMaxCol-1:childMaxCol;
      if(typeof(that["zdyValueChange_"+nowField.fieldId]) == "function") {
        that["zdyValueChange_"+nowField.fieldId](that,utils,pageUtils);
      }
      this.$forceUpdate();
    },
    /**
     * 根据页面的字段切换隐藏显示
     */
    changeByshowHideJsList() {
      var that = this;
      var pageSetInfo = that.pageSetInfo;
      var showHideJsList = that.pageSetInfo.showHideJsList;
      // console.log("showHideJsList================",showHideJsList);
      if(showHideJsList && showHideJsList.length > 0) {
        showHideJsList.forEach(element => {
          // var oneJsArr = element.split("_");
          var oneJs = element.substring(0,element.lastIndexOf("_"));
          var oneChangeField = element.substring(element.lastIndexOf("_")+1);
          // var x = "#{293:4223} == 2 && #{293:4224} == 2 && #{293:4225} == 2";
          var re = /#{[\d:_()]+}/g;
          var name_indexMap = pageSetInfo.name_indexMap;
          var needThList = [];
          var aaaa = [];
          while(aaaa = re.exec(oneJs)){
            if(aaaa != null) {
              var byFieldId = aaaa[0].substring(aaaa[0].indexOf(":")+1,aaaa[0].length-1);
              if(name_indexMap['name_'+byFieldId] >= 0) {
                  //本层是否有这个过滤字段
                  var fieldSetOne = pageSetInfo.fieldSet[name_indexMap['name_'+byFieldId]];
                  if(fieldSetOne && fieldSetOne.fieldId == byFieldId) {
                    needThList.push({
                      source:aaaa[0],
                      value:fieldSetOne.defaultCheckValue?fieldSetOne.defaultCheckValue:"''"
                    })
                  }
              }
            }
          }
          // console.log("needThList================",needThList);
          if(needThList.length > 0) {
            needThList.forEach(needThOne => {
              oneJs = oneJs.replace(needThOne.source,needThOne.value);
            });
            var nowIndex = name_indexMap['name_'+oneChangeField];
            var fieldSetOne = pageSetInfo.fieldSet[nowIndex];
            if(fieldSetOne  && (fieldSetOne.fieldId == oneChangeField)) {
              var nowHideState = fieldSetOne.ifHide;
              var ifChange = false;
              if(eval(oneJs)) {
                that.$set(fieldSetOne,"ifHide",false);
              } else {
                that.$set(fieldSetOne,"ifHide",true);
                ifChange = true;
              }
              //if(nowHideState != fieldSetOne.ifHide) {
              //  ifChange = true;
              //}
              //获取隐藏显示是否清空值的设置
              // console.log("fieldSetOne=============================",fieldSetOne);
              if(ifChange && fieldSetOne.ifChangeClean == 0) {
                pageUtils.clearFieldCheckValue(fieldSetOne,that);
              }
              //重新计算 这个元素后边的空余元素数量
              // if(nowIndex > 0) {
                // that.countFieldMiddelIndex(pageSetInfo,nowIndex,'prev');
              // }
            }
          }
          that.countFieldMiddelIndex(pageSetInfo,0,'prev');
        });
      }
      that.pageSetInfo = pageSetInfo;
    },
    /**
     * 计算字段距离下一个字段的个数
     */
    countFieldMiddelIndex(pageSetInfo,index,type){
      var that = this;
      var maxRowColJson = that.maxRowColJson;
      // var oneField = null;
      // if(type == "prev") {
      //   for (let previndex = index-1; previndex > 0; previndex--) {
      //     const prevField = pageSetInfo.fieldSet[previndex];
      //     if(!prevField.ifHide) {
      //       oneField = prevField;
      //       break;
      //     }
      //   }
      //   oneField = pageSetInfo.fieldSet[index-1];
      // } else {
      //   oneField = pageSetInfo.fieldSet[index];
      // }
      for (let allIndex = 0; allIndex < pageSetInfo.fieldSet.length; allIndex++) {
        const oneField = pageSetInfo.fieldSet[allIndex];  
        
        if(oneField && allIndex+1<pageSetInfo.fieldSet.length) {
          var middelIndex = oneField.middelIndex
          for (let nextindex = allIndex+1; nextindex < pageSetInfo.fieldSet.length; nextindex++) {
            var nextField = pageSetInfo.fieldSet[nextindex];
            if(!nextField.ifHide) {
              middelIndex = (nextField.row*(maxRowColJson.maxCol+1)+nextField.col) - (oneField.row*(maxRowColJson.maxCol+1) + oneField.col) - oneField.colSpan;
              // console.log("oneField========================prev===",oneField.fieldCnName,maxRowColJson,oneField,nextField,middelIndex);
              break;
            }
          }
          if(middelIndex == (maxRowColJson.maxCol+1) && oneField.col == 0) {
            middelIndex = 0;
          }
          if(middelIndex > maxRowColJson.maxCol) {
            var middelRow = ((middelIndex+(oneField.col+1))/(maxRowColJson.maxCol+1)).toFixed();
            if(middelRow>=2) {
              middelIndex = middelIndex - (middelRow-1)*(maxRowColJson.maxCol+1);
            }
          }
          oneField.middelIndex = middelIndex<0?0:middelIndex;
        }
      }
    },
    /**
     * 上移子表格数据
     */
    toUpChildOne(fieldOne,index) {
      if(index == 0) {
        var tmpOne = fieldOne.childPageJsonArr.splice(index,1);
        fieldOne.childPageJsonArr.push(tmpOne[0]);
      } else {
        var targetIndex = index-1;
        fieldOne.childPageJsonArr[index] = fieldOne.childPageJsonArr.splice(targetIndex, 1, fieldOne.childPageJsonArr[index])[0];
      }
      this.$forceUpdate();
    },
    /**
     * 下移子表格数据
     */
    toDownChildOne(fieldOne,index){
      if(index+1 == fieldOne.childPageJsonArr.length) {
        var tmpOne = fieldOne.childPageJsonArr.splice(index,1);
        fieldOne.childPageJsonArr.unshift(tmpOne[0]);
      } else {
        var targetIndex = index+1;
        fieldOne.childPageJsonArr[index] = fieldOne.childPageJsonArr.splice(targetIndex, 1, fieldOne.childPageJsonArr[index])[0];
      }
      this.$forceUpdate();
    },
    /**
     * 删除子表格数据
     */
    toDeleteChildOne(fieldOne,index){
      var that = this;
      fieldOne.childPageJsonArr.splice(index,1);
      if(typeof(that["zdyValueChange_"+fieldOne.fieldId]) == "function") {
        that["zdyValueChange_"+fieldOne.fieldId](that,utils,pageUtils);
      }
      this.$forceUpdate();
    },
    /**
     * 子表格有滚动条时，title滚动条联动异动
     */
    childLookHandleScroll(fieldOne,index,childIndex) {
      this.$refs['childTitleRowBox_'+index][0].scrollLeft = this.$refs['childDivBox_'+index+'_'+childIndex][0].scrollLeft;
      for (let forIndex = 0; forIndex < fieldOne.childPageJsonArr.length; forIndex++) {
        if(forIndex != childIndex) {
          this.$refs['childDivBox_'+index+'_'+forIndex][0].scrollLeft = this.$refs['childDivBox_'+index+'_'+childIndex][0].scrollLeft;
        }
      }
    },

    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh,dataInfo,toJsonInfo){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1 || ifRefresh == 2) {
        this.refreshevent();
      }
      if(ifRefresh == 2) {

      }
    },
    refreshevent() {
      var kw_look = this;
      kw_look.hasLoad = false;
      if(kw_look.tabCurrent > 0) {
        kw_look.refreshPrevTabCurrent = kw_look.tabCurrent;
      }
      kw_look.$nextTick(function(){
        // 默认本页刷新
        kw_look.initAtiached();
      });
    },
    /**
     * 获取最外层的的kw_look组件
     */
    getParentKwLook(callback,ifOneParent) {
      if(!ifOneParent) {
        ifOneParent = false;
      }
      console.log("callback==================",callback,ifOneParent);
      if(callback) {
        if(this.$listeners['getParentKwLook'] && !ifOneParent){
          var parentKwLook;
          this.$emit("getParentKwLook",val => {
              parentKwLook = val
          },ifOneParent);
          callback(parentKwLook);
        } else {
          callback(this);
        }
      } else {
        return this;
      }
    },
    getOneParentKwLook() {
      var parentKwLook;
      console.log("getOneParentKwLook======================",this,this.$listeners['getParentKwLook']);
      this.$emit("getParentKwLook",val => {
        parentKwLook = val
      },true);
      return parentKwLook;
    },
    /**
     * 获取当前页面的that对象
     */
    getNowKwLook(callback) {
      if(callback) {
        callback(this);
      } else {
        return this;
      }
    },
    /**
     * 预览页面时进行数据加载
     */
    previewInitLoad() {
      var that = this;
      if(that.isPreview == 1) {
        var previewPageSetInfo = JSON.parse(JSON.stringify(this.previewPageSetInfo));
        previewPageSetInfo.fieldSet = previewPageSetInfo.addFieldSet;
        var maxRow = 0;
        var maxCol = 0;
        var pageType = previewPageSetInfo.pageType;
        previewPageSetInfo.fieldSet.forEach(fieldOne => {
          var fieldRole = fieldOne.fieldRole
          var fieldType = 2;
          switch (fieldRole) {
            case 14://日期
            case 15://时间
              fieldType = 3;
              break;
            case 16://单值选择项
            case 17://多值选择项
            case 23://星期
              fieldType = 4;
              break;
            case 20://内部对象
            case 21://内部对象多值
            case 22://父级引用
              fieldType = 5;
              break;
            case 12://数字
            case 13://金额
              fieldType = 1;
              break;
            case 18://单文档
            case 19://多文档
              fieldType = 6;
              break;
            default:
              fieldType = 2;
              break;
            }
          fieldOne.fieldType = fieldType;
          if(fieldOne.fieldId <= 0 || pageType == 11 || fieldOne.dialogFieldAliasName) {
            fieldOne.ifUpdate = 0;
          }
          if(fieldOne.fieldRole == 16 || fieldOne.fieldRole == 17) {
            
            fieldOne.dicList = []
            for (let index = 1; index < 20; index++) {
              fieldOne.dicList.push({
                dicId:index,dicName:'字典'+index
              })
              
            }
          }
          var row = fieldOne.row;
          var col = fieldOne.col;
          if(row>maxRow) {
            maxRow = row;
          }
          if(col>maxCol) {
            maxCol = col;
          }
        });
        previewPageSetInfo.maxRow = maxRow;
        previewPageSetInfo.maxCol = maxCol;
        if(previewPageSetInfo.tabPageSet) {
          previewPageSetInfo.tabPageSet.forEach(tabPageOne => {
            tabPageOne.tableId = tabPageOne.relationObjId;
            tabPageOne.pageId = tabPageOne.tabPageId;
          });
        }
        

        this.initPageDataInfo({
          pageSet:previewPageSetInfo,
          initUpdateData:that.previewPageDataInfo
        },this);
        this.visitSource = this.previewVisitSource;

        this.hasLoad=false;
        this.$nextTick(function(){
          that.hasLoad=true;
        })
      }
    },
    
    /**
     * 进行打印功能
     */
    setLodop() {
      var that = this;
  //  调用getLodop函数，如果用户未安装打印插件则会返回false
      let LODOP = getLodop();
      //  如果返回false 用户未安装打印插件，弹出dialog提示引导用户跳转到安装页面
      var htmlContent = "";
      if (!LODOP) {
          htmlContent='打印控件未安装,请先将安装包根目录打印控件安装!'
          that.printDialogInfo = true;
      } else {
        htmlContent = '<body>' + document.getElementById('print_kw_box_'+that.pageId).innerHTML + '</body>';
        let direction = 1; //2
        //  打印初始化
        LODOP.PRINT_INIT("");
        //  打印方向 及纸张大小设置  这里是a4纸的尺寸
        LODOP.SET_PRINT_PAGESIZE(direction, "210mm", "297mm");
        //  设置打印字体大小及粗细
        LODOP.SET_PRINT_STYLE("FontSize", 18);
        LODOP.SET_PRINT_STYLE("Bold", 1);
        ///参数按顺序分别为，上下间距，左右间距，宽度，高度  
        //  这里根据形参判断是打印二维码 还是发货清单
        // LODOP.ADD_PRINT_HTML(0, 0, "100%", "100%", htmlContent);
        var json = that.pageInfo;
        var kwParam = "";
        var lookParam = that.GLOBAL.lookParam;
        lookParam.forEach(key => {
            kwParam+=(json[key]?json[key]:"")+"_";
        });
        kwParam = utils.kwBtoa(kwParam);
        var url = "look?noHead=1&kw_param=" + kwParam;
        LODOP.ADD_PRINT_HTM(0,0,"100%","100%",that.getStyle() + htmlContent);
        // LODOP.ADD_PRINT_HTML(0,0,"100%","100%","URL:"+url);
        // 最后弹出打印预览界面
        LODOP.PREVIEW();
      }
    },
    getStyle: function () {
      var str = "",
        styles = document.querySelectorAll('style,link');
      for (var i = 0; i < styles.length; i++) {
        str += styles[i].outerHTML;
      }
      // str += "<style>" + (this.options.noPrint ? this.options.noPrint : '.no-print') + "{display:none;}</style>";

      return str;
    },
    getParentKwList:function(callback){
      var parentKwList = null;
      this.$emit("getParentKwList",val => {
        parentKwList = val
      });
      callback(parentKwList);
    },
    /**
     * 打开页面设置功能
     */
    toOpenPageSet(sourceType) {
      var that = this;
      let routeData = that.$router.resolve({
        name: 'PageShowSet',
        query: {
            pageId:that.pageId,
            sourceType:sourceType
        }
      })
      console.log("routeData.href================",routeData.href);
      window.open(routeData.href, '_blank')
    },
    toImgPrint() { // 转图片打印
      html2canvas(this.$refs.print_kw_box, {
        backgroundColor: null,
        useCORS: true,
        windowHeight: document.body.scrollHeight
      }).then((canvas) => {
        // let url = canvas.toDataURL('image/jpeg', 1.0)
        const url = canvas.toDataURL()
        // this.img = url
        printJS({
          printable: url,
          type: 'image',
          documentTitle: '打印'
        })
        console.log(url)
      })
    },
    //打开多条件插件设置
    openShowStyle44(item,index){
      this.tjPlugDialogInfo.fieldIndex = index;
      var parentKwLook = null;
      this.getParentKwLook(val => {
          parentKwLook = val
      });
      console.log("parentKwLook===================",parentKwLook);
      var tableId = 0;
      if(!parentKwLook) {
        parentKwLook = this;
      }
      parentKwLook.pageSetInfo.fieldSet.forEach(element => {
        if(element.styleSet && element.styleSet.showStyle == 43) {
          tableId = element.defaultValStr;
        }
      });
      var fieldOne = this.pageSetInfo.fieldSet[index];
      var childPageJsonArr44 = [];
      this.$set(fieldOne,"childPageJsonArr44",childPageJsonArr44);
      if(fieldOne.childPageJsonArr && fieldOne.childPageJsonArr.length > 0) {
        fieldOne.childPageJsonArr.forEach(element => {
          var tjPlugId = element.fieldSet[0].defaultValStr;
          var nameStr = element.fieldSet[1].defaultValStr;
          var resultStr = element.fieldSet[2].defaultValStr;
          childPageJsonArr44.push({
            tjIdJson:{
              tjPlugId:tjPlugId,
              nameStr:nameStr,
              resultStr:resultStr
            }
          })
        })
      }
      this.tjPlugDialogInfo.tableId = tableId;
      this.tjPlugDialogInfo.ifLoad = true;
    },
    confirmShowStyle44(){
      var that = this;
      var fieldIndex = this.tjPlugDialogInfo.fieldIndex;
      var fieldOne = this.pageSetInfo.fieldSet[fieldIndex];
      var childPageJsonArr44 = fieldOne.childPageJsonArr44;
      this.$set(fieldOne,"childPageJsonArr",[]);
      childPageJsonArr44.forEach(element => {
        that.addChildJson(fieldOne);
        var childAddOne = fieldOne.childPageJsonArr[fieldOne.childPageJsonArr.length-1];
        that.$set(childAddOne.fieldSet[0],"defaultValStr",element.tjIdJson.tjPlugId);
        childAddOne.fieldSet[0].defaultValStr = element.tjIdJson.tjPlugId;
        childAddOne.fieldSet[1].defaultValStr = element.tjIdJson.nameStr;
        childAddOne.fieldSet[2].defaultValStr = element.tjIdJson.resultStr;
      });
      console.log("fieldOne==================",fieldOne);
      this.closeShowStyle44();
    },
    closeShowStyle44(){
      this.tjPlugDialogInfo.ifLoad = false;
    },
    //对象选择选中后的回调
    bindElementChange43(fieldOne,index) {
      if(fieldOne.defaultValStrJson) {
        this.$set(this.pageSetInfo.fieldSet[index],"defaultValStr",fieldOne.defaultValStrJson.tableId);
        this.$set(this.pageSetInfo.fieldSet[index+1],"defaultValStr",fieldOne.defaultValStrJson.tableCnName);
      }
      this.bindElementChange(fieldOne);
    },
    //kwLook页面的boxClick
    kwLookPageBoxClick(event) {
      var that = this;
      var kwLookPageBoxClickJs = that.pageSetInfo.styleSet.kwLookPageBoxClickJs;
      if(kwLookPageBoxClickJs) {
        // eval(kwLookPageBoxClickJs);
        var parentKwLook = that.getOneParentKwLook();
        console.log("parentKwLook=======================",parentKwLook);
        if(parentKwLook) {
          if(parentKwLook.dataInfo['BLOCK_SHOW_47'] == 0) {
            parentKwLook.dataInfo['BLOCK_SHOW_47'] = 1;
          } else {
            parentKwLook.dataInfo['BLOCK_SHOW_47'] = 0;
          }
        }
        event.stopPropagation();
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .isFixed{position:fixed;background-color:#Fff;top:0;z-index:900;width: 100%;}
/* 默认title */
.curriculumTitle{color: #4B4B4B;font-size: 16px;font-weight: bold;padding: 10px;margin: 0 10px;background: #fff;margin-top: 12px;border: 1px solid #F1F1F1;border-bottom: none;border-top-left-radius: 5x;border-top-right-radius: 5px;position: relative}
.loadmore{font-size: 12px;color: #929192;float: right}
.curriculumTitle .rightTit{font-size: 12px;color: #CDCDCD;float: right}

/*PC*/
.curriculumTitle_pc{color: #4B4B4B;font-size: 16px;font-weight: bold;padding: 10px 0;margin-top: 12px;position: relative}
.curriculumTitle_pc .rightTit{font-size: 12px;color: #CDCDCD;float: right}


/* 考试 */
.ExaminationCurriculumTitle{color: #4B4B4B;font-size: 16px;font-weight: bold;padding: 0 10px;margin: 0 10px;background: #fff;margin-top: 12px;}
.ExaminationCurriculumTitle .rightTit{font-size: 12px;color: #CDCDCD;float: right}

/*标题图片设置*/
.curriculumTitleBg{color: #4B4B4B;font-size: 16px;font-weight: bold;margin: 0 10px;background: #fff;margin-top: 12px;}
.curriculumTitleBg .loadmore{font-size: 12px;color: #fff;position:absolute;right:0;top: 50%;transform: translateY(-50%)}

.tabname:before{content: '';display:inline-block;width:5px;height:20px;background:#FB3E14;border-radius:5px;margin-right:5px;vertical-align: bottom;}
.tabname_pc{font-size: 28px}
/* .tabname_pc:before{content: '';display:inline-block;width:5px;height:28px;background:#FB3E14;border-radius:5px;margin-right:5px;vertical-align: sub;} */

/* 详情页（中分） */
.MiddleScore{margin: 0 10px;display: table;background: #fff;border-right: 1px solid #EBEBEB;border-left: 1px solid #EBEBEB;border-top: 1px solid #EBEBEB}
.MiddleScoreBox{width: 100%}
.MiddleScoreBox .MiddleScore:first-child{border-top-left-radius: 5px;border-top-right-radius: 5px}
.MiddleScoreBox .MiddleScore:last-child{border-bottom: 1px solid #EBEBEB;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px}

.MiddleScore>div {display: table-cell;vertical-align: middle;}
.MiddleScoreLeft{width: 100px;color: #4C4C4C;font-size: 16px;border-right: 1px solid #EBEBEB;
}
.MiddleScoreLeftTitle{text-align: center;display: block;width: 82px;margin: 0 auto;}
.MiddleScoreRight{width: 126px;display: table-cell}

.bgImageBox{height: 80px;margin-left: 10px;display: flex;flex-wrap: wrap;box-sizing: border-box;align-items: center}
.bgImageName{font-size: 14px}



.ViewMore{width: 94px;color: #4E4E4E;background: #EDEDED;font-size: 12px;height: 25px;line-height: 25px;border-radius: 25px;margin: 0 auto 20px;text-align: center;}
.tabsBox{background: #fff;display: flex;position:relative;align-items: center}
.tabsBox_pc{background: #fff;position:relative;}
.botLine:before {content: ' ';border-bottom: 1px solid #EBEBEB;display: inline-block;position: absolute;bottom: 3px;width:100%;z-index: 2;}
/* .tabsBoxSticky{padding: 10px;background: #fff;} */
.tabsBoxSticky{padding:0 10px;background: #fff;}
.taskTitle{color: #424242;font-size: 16px;font-weight: bold;margin: 0 10px;}
.mainTitle{color: #333333;font-size: 16px;background: #fff;padding: 20px 10px 3px;display: block;font-weight: bold}
.viceTitle{color: #9B9B9B;font-size: 14px;background: #fff;padding: 0 10px 4px;}
.defaultStyleBox{font-size: 14px;color: #9B9B9B;display: flex;justify-content: space-between;}
.defaultStyle{display: inline-block;color:#606266;font-size: 14px;line-height: 20px;}
.personnelHeadPortrait{margin: 10px 0;padding: 10px;background: #fff}

.orderNum{display:flex;justify-content: space-between;font-size: 13px;background:#fff}
.leftPart{color:#999}
.leftPart_pc{}
.rightPart{color:#999}

.titleName{color:#333}
.leftIcon{width:14px;height:14px;vertical-align: middle;margin-right: 6px}


/* .listButton{color:#ffffff;font-size: 14px;background: linear-gradient(to right, #FF460E, #F56B20);height: 1.5rem;line-height: 1.5rem;border-radius: 1.5rem;padding: 0 5px;min-width: 5rem;display: inline-block;text-align: center;margin-right: 10px;margin-bottom: 10px;} */
.listButton{font-size: 14px;text-align: center;vertical-align: middle;color: #FFF;background-color: #409EFF;border-color: #409EFF;border: 1px solid #DCDFE6;padding: 6px 10px;border-radius: 4px;}
.titleBottomButton{margin: 10px 10px 0 10px;display: flex;justify-content: center;align-items: center}
.ButtonBlock{background: #fff;display: flex;justify-content: flex-end;}

.informationBox{padding: 10px;background: #fff;box-shadow: 0 5px 15px #E9E9E9;border-radius: 10px;width: 325px;position: absolute;top: 125px;left: 15px}
/* .details_card{position: relative} */
.image_bg{position: absolute;width: 350px;top: 0;left: 0}


.medalText{font-size: 14px;color: #676767;font-weight: bold}

.botNameLeft {width:100%;border-right:1px solid #f3f3f3}
.botNameRight {width:100%;}
.botNameItem {text-align:center}
.toInline {display:inline-block}
.tipblock {padding:3px 6px;color:#F9A86B;border:1px solid #F9A86B;font-size:12px;border-radius: 5px;margin-left:5px;}
.btnType {padding:3px 20px; background: #FD4F12;color:#fff!important;border-radius: 30px}
.medalText{font-size: 14px;color: #676767;font-weight: bold}
.medalText{font-size: 14px;color: #676767;font-weight: bold}

.RankingImg{width: 350px;display: block}
.tabbg{background:#FF4431;padding-bottom:0}
.jumpIcon {width:15px;height:15px;vertical-align: middle}
.jumpIcon_pc {width:23px;height:23px;vertical-align: sub}

.customTitle:before{content: '';display:inline-block;width:5px;height:20px;background:#FB3E14;border-radius:5px;margin-right:5px;vertical-align: bottom;}
.customTitle{vertical-align: middle;margin-right: 20px}
/*.customTitle_pc{vertical-align: middle;margin-right: 20px}*/

.titBgBox {position: relative}
.quanIcon {position:absolute;left:-15px;top:50%;transform: translateY(-50%);width:5px;height:5px;border:2px solid #FF4F52;border-radius: 50%;background:#FFF}
.titNum {position:absolute;left:8px;top:45%;transform: translateY(-50%);color:#FF6186;font-size: 18px}
.titimg {height:32px;width:100%;}
.tabnameImg {position: absolute;left: 35px;top: 50%;transform: translateY(-50%);color: #fff;font-size: 15px;}
.titBgList3 {margin-left: 12px;position: relative;}
.titBgList3:before {content: ' ';border-left: 2px solid #E9EDF0;display: inline-block;height: 100%;position: absolute;left: -2px;margin-top: 14px;}
/*.titBgList{margin-top: 60px}*/

.titleImgBox{float:left;}


.clearfix:after{
  content: "";
  display: block;
  height: 0;
  clear:both;
  visibility: hidden;
}
.clearfix{
  zoom: 1;
}

.titBgImg {width:100px;height:28px;}
.tabTitPos {display: inline-block;font-size:16px;}

.titleBtnImg{display: inline-block;width: 20px;height: 20px;margin-right: 3px;}

.suspensionBtn{position: fixed;right: 0;font-size: 16px;border: 1px solid #000;background: #000;opacity: 0.4;color: #fff;padding: 0 10px;margin: 0;border-radius: 15px 0 0 15px;height: 30px;line-height: 30px;z-index:999}

.ellipsisBtn{position: fixed;right: 10px;top: 43px;font-size: 16px;border: 1px solid #000;background: #000;opacity: 0.4;color: #fff;text-align:center;border-radius: 15px;width:30px;height: 30px;line-height: 20px;z-index:999;padding: 0}

/* 我已同意 */
.prevSaveChecked{display: flex;padding: 10px 0 10px 10px;background: #fff;}
.prevSaveCheckedBtn{color: red;padding: 0;margin: 0;height: 20px;line-height: 20px;background: transparent;border: none}


/* 签约取消屏幕右下角设置 */
.positionRightBottom{position: absolute;bottom: 0;right: 0;width: 50%}
/* 签约取消屏幕左下角设置 */
.positionLeftBottom{position: absolute;bottom: 0;left: 0;width: 50%}

.floatLeft{float: left}
.floatRight{float: right}

  .tabLeftWidth{width: 68%;}
  .tabRightWidth{width: 30%;}
  .bottomBlockDistance{margin-top: 20px}

.newPayBox{border:1px solid #eee;border-radius: 10px;margin: 0 auto;background-color: #F7F7F7;}
.apply_up{margin-top: 10px;background-color: #fff;text-align: center;}

  /* 主标题默认style */
  .fieldDefault9{background:#fff;color:#666;font-size:14px;}
  /* 副标题默认style */
  .fieldDefault10{background:#fff;}
  .fieldNameBoxDefault10{display:inline-block;align-items:center;}
  .fieldNameDefault10{color:#666;font-size:16px;}
  .fieldValueDefault10{flex:1;color:#666;font-size:14px;word-break:break-all;display:inline-block;}
  /* 按钮默认样式 */
  .buttonDefault10{width:350px;}

.kw_look{
  background: #fff;
}

  /* 添加修改页面 循环字段的col的 默认样式 background: #e5e9f2; */
.forFieldDefault{
  padding: 3px;margin: 3px 0;
}
.forFieldDefaultNull{
  padding: 3px;margin: 3px 0;min-height: 45px;
}



</style>
<style>
  .is_child_look .pageFieldNameStyleSet{
    display: none;
  }
  .radio_right{margin-right: 30px !important;}
  .radio_right .el-radio__input{float: right;}

  /* .Signing_form .el-form-item__label{text-align: left;padding:0 0 0 10px;} */
</style>
